export const applicationHost = "index.altius.org";
export const applicationProductionPort = 443;
export const applicationProductionHost = applicationHost;
export const applicationProductionProxyPort = 8443;
export const applicationDevelopmentPort = 3000;
export const applicationDevelopmentHost = applicationHost;

//export const annotationHost = "18.191.132.31";
//export const annotationPort = "8000";

export const isAnnotationsServiceEnabled = false;
export const annotationScheme = "https";
export const annotationHost = "annotations.altius.org";
export const annotationPort = "8443"; // SSL over 8443

export const mapIndexDHSScheme = "https";
export const mapIndexDHSHost = "meuleman-map-index-dhs.altius.org";
export const mapIndexDHSPort = "443";
export const mapIndexDHSSetName = "Index_DHS";

export const applicationEndpointRootURL = "meuleman-higlass-us-west-2.altius.org";
export const applicationDevEndpointRootURL = "meuleman-higlass-2-us-west-2.altius.org";

export const applicationTabixRootURL = `https://${applicationEndpointRootURL}/tabix/index`;
export const applicationHiGlassServerEndpointRootURL = `https://${applicationEndpointRootURL}/api/v1`;
export const applicationHiGlassDevServerEndpointRootURL = `https://${applicationDevEndpointRootURL}/api/v1`; // "https://dev-explore.altius.org/api/v1;

export const urlProxyURL = `https://${applicationHost}:9001`;
export const recommenderProxyURL = `https://epilogos.altius.org:9002`; // TO-DO: set up port 9002 service on Index host
export const tabixServiceURL = `https://${applicationHost}:9003`;

export const defaultHgViewClickPageX = -1;
export const defaultHgViewClickTimePrevious = -1;
export const defaultHgViewClickTimeCurrent = -1;
export const applicationPortalClickDeltaTimer = 1000;
export const applicationPortalClickDeltaThreshold = 500;
export const applicationAutocompleteInputMinimumLength = 2;
export const defaultHgViewGenePaddingFraction = 0.2;
export const defaultHgViewIndexDHSPadding = 250;
export const defaultHgViewRegionPadding = 2500;
export const defaultHgViewRegionUpstreamPadding = 5000;
export const defaultHgViewRegionDownstreamPadding = 5000;
export const defaultHgViewRegionPositionRefreshTimer = 1500;
export const defaultAggregationType = "bkfq_2binWide_allSample";
export const defaultIndexDHSHiglassTranscriptsTrackHeight = 42; /* (21 px x 2 rows) */
export const defaultIndexDHSHiglassTranscriptsMobileTrackPortraitMaxRows = 3;
export const defaultIndexDHSHiglassTranscriptsMobileTrackPortraitHeight = (28 * defaultIndexDHSHiglassTranscriptsMobileTrackPortraitMaxRows) + 10;
export const defaultIndexDHSHiglassTranscriptsMobileTrackLandscapeMaxRows = 2;
export const defaultIndexDHSHiglassTranscriptsMobileTrackLandscapeHeight = (28 * defaultIndexDHSHiglassTranscriptsMobileTrackLandscapeMaxRows) + 10;
export const defaultGeneAnnotationsHiglassTranscriptsTrackHeight = 7 * 21;
export const defaultGeneAnnotationsHiglassTranscriptsMobileTrackPortraitMaxRows = 3;
// export const defaultGeneAnnotationsHiglassTranscriptsMobileTrackPortraitHeight = 60;
export const defaultGeneAnnotationsHiglassTranscriptsMobileTrackPortraitHeight = 80;
export const defaultGeneAnnotationsHiglassTranscriptsMobileTrackLandscapeMaxRows = 3;
export const defaultGeneAnnotationsHiglassTranscriptsMobileTrackLandscapeHeight = 60;
export const defaultGeneAnnotationsHiglassTranscriptsMobileTrackHeight = defaultGeneAnnotationsHiglassTranscriptsMobileTrackPortraitHeight;
export const defaultGeneAnnotationsHiglassTranscriptsDesktopTrackMaxRows = 6;
export const defaultGeneAnnotationsHiglassTranscriptsDesktopTrackMinHeight = 200;
export const defaultChromosomeTrackHeight = 25;
export const defaultSpacerMobileTrackHeight = 20;
export const portalExemplarJumpButtonLabel = "I'm Feeling Lucky";

export const defaultApplicationRecommenderButtonHideShowThreshold = 25000;
export const defaultApplicationRecommenderTabixSource = "remote";
export const defaultApplicationRecommenderOutputDestination = "stdout";
export const defaultApplicationRecommenderOutputFormat = "JSON";

export const defaultApplicationRecommenderV3TabixSource = defaultApplicationRecommenderTabixSource;
export const defaultApplicationRecommenderV3OutputDestination = defaultApplicationRecommenderOutputDestination;
export const defaultApplicationRecommenderV3OutputFormat = defaultApplicationRecommenderOutputFormat;
export const defaultApplicationRecommenderV3ButtonHideShowThreshold = defaultApplicationRecommenderButtonHideShowThreshold;
export const defaultApplicationRecommenderV3WindowSizeKey = "50k";

export const defaultApplicationNavbarHeight = "55px";
export const defaultApplicationQueryViewPaddingTop = 50;
export const defaultApplicationRegionIndicatorContentTopOffset = 39;
export const defaultApplicationRegionIndicatorContentMainViewOnlyTopOffset = 8;

export const defaultRecommenderGemRefreshTimer = 4000;
export const defaultRecommenderGemRefreshInViewerApplicationTimer = 60000; // every minute
export const defaultQueryTargetLockFlag = true;

export const defaultApplicationBinSize = 20;

export const mobileThresholds = {
  portalContentQueryHeight: "330px",
  maxHeight: "480px",
  maxWidth: "420px"
};

export const applicationRegionTypes = {
  "proteinCodings" : "proteinCodings",
  "transcriptionFactors" : "transcriptionFactors",
  "roi" : "roi"
};

export const applicationBinShift = 100;

export const defaultSingleGroupDropdownOpen = false;
export const defaultSingleGroupSearchInputValue = "";
export const defaultSingleGroupSearchInputPlaceholder = "Specify an interval or gene";

export const defaultSamplesDropdownIsOpen = false;

export const allComponent = {
  "all": {
    "componentIndex": 1,
    "samples": 733,
    "active": true,
    "longName": "All samples",
    "color": "#eeeeee"
  }
};

export const drawerTitleByType = {
  "proteinCodings" : "Protein-coding",
  "transcriptionFactors" : "TFs",
  "roi": "roi",
  "simsearch": "simsearch",
};

export const drawerTypeByName = {
  "proteinCodings" : "proteinCodings",
  "transcriptionFactors" : "transcriptionFactors",
  "roi" : "roi",
  "simsearch": "simsearch",
};

export const components = {
  "placentalTrophoblast": {
    "componentIndex": 7,
    "samples": 18,
    "active": true,
    "longName": "Placental / trophoblast",
    "filenameKey": "placentalTrophoblast",
    "color": "#FFE500"
  },
  "lymphoid": {
    "componentIndex": 5,
    "samples": 61,
    "active": true,
    "longName": "Lymphoid",
    "filenameKey": "lymphoid",
    "color": "#FE8102"
  },
  "myeloidErythroid": {
    "componentIndex": 15,
    "samples": 47,
    "active": true,
    "longName": "Myeloid / erythroid",
    "filenameKey": "myeloidErythroid",
    "color": "#FF0000"
  },
  "cardiac": {
    "componentIndex": 9,
    "samples": 32,
    "active": true,
    "longName": "Cardiac",
    "filenameKey": "cardiac",
    "color": "#07AF00"
  },
  "musculoskeletal": {
    "componentIndex": 12,
    "samples": 61,
    "active": true,
    "longName": "Musculoskeletal",
    "filenameKey": "musculoskeletal",
    "color": "#4C7D14"
  },
  "vascularEndothelial": {
    "componentIndex": 14,
    "samples": 25,
    "active": true,
    "longName": "Vascular / endothelial",
    "filenameKey": "vascularEndothelial",
    "color": "#414613"
  },
  "primitiveEmbryonic": {
    "componentIndex": 3,
    "samples": 35,
    "active": true,
    "longName": "Primitive / embryonic",
    "filenameKey": "primitiveEmbyronic",
    "color": "#05C1D9"
  },
  "neural": {
    "componentIndex": 8,
    "samples": 56,
    "active": true,
    "longName": "Neural",
    "filenameKey": "neural",
    "color": "#0467FD"
  },
  "digestive": {
    "componentIndex": 13,
    "samples": 55,
    "active": true,
    "longName": "Digestive",
    "filenameKey": "digestive",
    "color": "#009588"
  },
  "stromalA": {
    "componentIndex": 2,
    "samples": 110,
    "active": true,
    "longName": "Stromal A",
    "filenameKey": "stromalA",
    "color": "#BB2DD4"
  },
  "stromalB": {
    "componentIndex": 4,
    "samples": 33,
    "active": true,
    "longName": "Stromal B",
    "filenameKey": "stromalB",
    "color": "#7A00FF"
  },
  "renalCancer": {
    "componentIndex": 6,
    "samples": 28,
    "active": true,
    "longName": "Renal / cancer",
    "filenameKey": "renalCancer",
    "color": "#4A6876"
  },
  "cancerEpithelial": {
    "componentIndex": 16,
    "samples": 54,
    "active": true,
    "longName": "Cancer / epithelial",
    "filenameKey": "cancerEpithelial",
    "color": "#08245B"
  },
  "pulmonaryDevelopment": {
    "componentIndex": 11,
    "samples": 42,
    "active": true,
    "longName": "Pulmonary devel.",
    "filenameKey": "pulmonaryDevel",
    "color": "#B9461D"
  },
  "organDevelopmentRenal": {
    "componentIndex": 10,
    "samples": 76,
    "active": true,
    "longName": "Organ devel. / renal",
    "filenameKey": "organDevelRenal",
    "color": "#692108"
  },
  "tissueInvariant": {
    "componentIndex": 17,
    "samples": 733,
    "active": false,
    "longName": "Tissue invariant",
    "filenameKey": "all",
    "color": "#eee"
  }
};

export const componentsEncode2024_042924 = {
  "LymphoidBcell": {
    "recordIndex": 0,
    "componentIndex": 28,
    "active": true,
    "longName": "Lymphoid (B-cell)",
    "filenameKey": "LymphoidBcell",
    "color": "#BB2DD4"
  },
  "LymphoidTcellNKcell": {
    "recordIndex": 1,
    "componentIndex": 7,
    "active": true,
    "longName": "Lymphoid (T-cell/NK-cell)",
    "filenameKey": "LymphoidTcellNKcell",
    "color": "#E6009B"
  },
  "MyeloidMonocyte": {
    "recordIndex": 2,
    "componentIndex": 3,
    "active": true,
    "longName": "Myeloid (Monocyte)",
    "filenameKey": "MyeloidMonocyte",
    "color": "#FFDE00"
  },
  "MyeloidMacrophage": {
    "recordIndex": 3,
    "componentIndex": 26,
    "active": true,
    "longName": "Myeloid (Macrophage)",
    "filenameKey": "MyeloidMacrophage",
    "color": "#FF7600"
  },
  "Erythroid": {
    "recordIndex": 4,
    "componentIndex": 12,
    "active": true,
    "longName": "Erythroid",
    "filenameKey": "Erythroid",
    "color": "#ED2024"
  },
  "Myeloidprogenitor": {
    "recordIndex": 5,
    "componentIndex": 15,
    "active": true,
    "longName": "Myeloid progenitor",
    "filenameKey": "Myeloidprogenitor",
    "color": "#AE1618"
  },
  "AdulttissuesCardiac": {
    "recordIndex": 6,
    "componentIndex": 6,
    "active": true,
    "longName": "Adult tissues / Cardiac",
    "filenameKey": "AdulttissuesCardiac",
    "color": "#414613"
  },
  "AdulttissuesEndocrine": {
    "recordIndex": 7,
    "componentIndex": 16,
    "active": true,
    "longName": "Adult tissues / Endocrine",
    "filenameKey": "AdulttissuesEndocrine",
    "color": "#32A63A"
  },
  "Thyroid": {
    "recordIndex": 8,
    "componentIndex": 29,
    "active": true,
    "longName": "Thyroid",
    "filenameKey": "Thyroid",
    "color": "#3BE796"
  },
  "Adrenal": {
    "recordIndex": 9,
    "componentIndex": 25,
    "active": true,
    "longName": "Adrenal",
    "filenameKey": "Adrenal",
    "color": "#00AD95"
  },
  "Digestive": {
    "recordIndex": 10,
    "componentIndex": 11,
    "active": true,
    "longName": "Digestive",
    "filenameKey": "Digestive",
    "color": "#4A6876"
  },
  "AdulttissuesMuscle": {
    "recordIndex": 11,
    "componentIndex": 19,
    "active": true,
    "longName": "Adult tissues / Muscle",
    "filenameKey": "AdulttissuesMuscle",
    "color": "#08245B"
  },
  "NeuralBasalganglia": {
    "recordIndex": 12,
    "componentIndex": 4,
    "active": true,
    "longName": "Neural (Basal ganglia)",
    "filenameKey": "NeuralBasalganglia",
    "color": "#0479FD"
  },
  "NeuralCereballar": {
    "recordIndex": 13,
    "componentIndex": 14,
    "active": true,
    "longName": "Neural (Cereballar)",
    "filenameKey": "NeuralCereballar",
    "color": "#37C1F1"
  },
  "NeuralFetal": {
    "recordIndex": 14,
    "componentIndex": 27,
    "active": true,
    "longName": "Neural (Fetal)",
    "filenameKey": "NeuralFetal",
    "color": "#A1EFFF"
  },
  "StromalA": {
    "recordIndex": 15,
    "componentIndex": 24,
    "active": true,
    "longName": "Stromal A",
    "filenameKey": "StromalA",
    "color": "#45316B"
  },
  "StromalB": {
    "recordIndex": 16,
    "componentIndex": 2,
    "active": true,
    "longName": "Stromal B",
    "filenameKey": "StromalB",
    "color": "#6B54A3"
  },
  "Endothelial": {
    "recordIndex": 17,
    "componentIndex": 8,
    "active": true,
    "longName": "Endothelial",
    "filenameKey": "Endothelial",
    "color": "#759CD5"
  },
  "EpithelialA": {
    "recordIndex": 18,
    "componentIndex": 13,
    "active": true,
    "longName": "Epithelial A",
    "filenameKey": "EpithelialA",
    "color": "#FEF3BB"
  },
  "EpithelialB": {
    "recordIndex": 19,
    "componentIndex": 18,
    "active": true,
    "longName": "Epithelial B",
    "filenameKey": "EpithelialB",
    "color": "#FFDAB9"
  },
  "RenalEpithelial": {
    "recordIndex": 20,
    "componentIndex": 5,
    "active": true,
    "longName": "Renal (Epithelial)",
    "filenameKey": "RenalEpithelial",
    "color": "#FFC26A"
  },
  "RenalFetal": {
    "recordIndex": 21,
    "componentIndex": 21,
    "active": true,
    "longName": "Renal (Fetal)",
    "filenameKey": "RenalFetal",
    "color": "#D0D2F8"
  },
  "RespiratoryFetal": {
    "recordIndex": 22,
    "componentIndex": 22,
    "active": true,
    "longName": "Respiratory (Fetal)",
    "filenameKey": "RespiratoryFetal",
    "color": "#C2FFED"
  },
  "MusculoskeletalFetal": {
    "recordIndex": 23,
    "componentIndex": 20,
    "active": true,
    "longName": "Musculoskeletal (Fetal)",
    "filenameKey": "MusculoskeletalFetal",
    "color": "#C2FF99"
  },
  "CardiacFetal": {
    "recordIndex": 24,
    "componentIndex": 17,
    "active": true,
    "longName": "Cardiac (Fetal)",
    "filenameKey": "CardiacFetal",
    "color": "#8CC63F"
  },
  "PlacentalA": {
    "recordIndex": 25,
    "componentIndex": 9,
    "active": true,
    "longName": "Placental A",
    "filenameKey": "PlacentalA",
    "color": "#D48EB8"
  },
  "PlacentalB": {
    "recordIndex": 26,
    "componentIndex": 10,
    "active": true,
    "longName": "Placental B",
    "filenameKey": "PlacentalB",
    "color": "#FF9BC7"
  },
  "Embryonic": {
    "recordIndex": 27,
    "componentIndex": 23,
    "active": true,
    "longName": "Embryonic",
    "filenameKey": "Embryonic",
    "color": "#FFABF1"
  },
  "Tissueinvariant": {
    "recordIndex": 28,
    "componentIndex": 1,
    "active": true,
    "longName": "Tissue invariant",
    "filenameKey": "Tissueinvariant",
    "color": "#E7E9E9"
  }
};

export const componentsEncode2024_011924 = {
  "naturalKillerCells": {
    "componentIndex": 1,
    "active": true,
    "longName": "Natural killer cells",
    "filenameKey": "naturalKillerCells",
    "color": "#BB2DD4"
  },
  "bCells": {
    "componentIndex": 2,
    "active": true,
    "longName": "B cells",
    "filenameKey": "bCells",
    "color": "#E6009B"
  },
  "cd4Slash3A": {
    "componentIndex": 3,
    "active": true,
    "longName": "CD4/3 (A)",
    "filenameKey": "cd4Slash3A",
    "color": "#B8461B"
  },
  "cd4Slash3B": {
    "componentIndex": 4,
    "active": true,
    "longName": "CD4/3 (B)",
    "filenameKey": "cd4Slash3B",
    "color": "#E6550D"
  },
  "cd4Slash3C": {
    "componentIndex": 5,
    "active": true,
    "longName": "CD4/3 (C)",
    "filenameKey": "cd4Slash3C",
    "color": "#FD8D3C"
  },
  "tCellsA": {
    "componentIndex": 6,
    "active": true,
    "longName": "T cells (A)",
    "filenameKey": "tCellsA",
    "color": "#FBB571"
  },
  "tCellsB": {
    "componentIndex": 7,
    "active": true,
    "longName": "T cells (B)",
    "filenameKey": "tCellsB",
    "color": "#FED4DE"
  },
  "cd34PlusProgenitor": {
    "componentIndex": 8,
    "active": true,
    "longName": "CD34+ progenitor",
    "filenameKey": "cd34PlusProgenitor",
    "color": "#ED2024"
  },
  "myeloid": {
    "componentIndex": 9,
    "active": true,
    "longName": "Myeloid",
    "filenameKey": "myeloid",
    "color": "#AE1618"
  },
  "k562": {
    "componentIndex": 10,
    "active": true,
    "longName": "K562",
    "filenameKey": "k562",
    "color": "#92171A"
  },
  "lungCancerCellLines": {
    "componentIndex": 11,
    "active": true,
    "longName": "Lung cancer cell lines",
    "filenameKey": "lungCancerCellLines",
    "color": "#8CC63F"
  },
  "respiratoryMuscular": {
    "componentIndex": 12,
    "active": true,
    "longName": "Respiratory / muscular",
    "filenameKey": "respiratoryMuscular",
    "color": "#DDE223"
  },
  "cerebralCortex": {
    "componentIndex": 13,
    "active": true,
    "longName": "Cerebral cortex",
    "filenameKey": "cerebralCortex",
    "color": "#37C1F1"
  },
  "cerebellarHemisphere": {
    "componentIndex": 14,
    "active": true,
    "longName": "Cerebellar hemisphere",
    "filenameKey": "cerebellarHemisphere",
    "color": "#2E97BC"
  },
  "brainA": {
    "componentIndex": 15,
    "active": true,
    "longName": "Brain (A)",
    "filenameKey": "brainA",
    "color": "#207593"
  },
  "brainB": {
    "componentIndex": 16,
    "active": true,
    "longName": "Brain (B)",
    "filenameKey": "mixed",
    "color": "#105986"
  },
  "gastroEndocrineSystem": {
    "componentIndex": 17,
    "active": true,
    "longName": "Gastro-endocrine system",
    "filenameKey": "gastroEndocrineSystem",
    "color": "#00AD95"
  },
  "renal": {
    "componentIndex": 18,
    "active": true,
    "longName": "Renal",
    "filenameKey": "renal",
    "color": "#526E7D"
  },
  "epithelial": {
    "componentIndex": 19,
    "active": true,
    "longName": "Epithelial",
    "filenameKey": "epithelial",
    "color": "#FFDAB9"
  },
  "stromalCells": {
    "componentIndex": 20,
    "active": true,
    "longName": "Stromal cells",
    "filenameKey": "stromalCells",
    "color": "#6B54A3"
  },
  "t47d": {
    "componentIndex": 21,
    "active": true,
    "longName": "T-47D",
    "filenameKey": "t47d",
    "color": "#2C674A"
  },
  "mcf7": {
    "componentIndex": 22,
    "active": true,
    "longName": "MCF-7",
    "filenameKey": "mcf7",
    "color": "#2C924A"
  },
  "pluripotentCells": {
    "componentIndex": 23,
    "active": true,
    "longName": "Pluripotent cells",
    "filenameKey": "pluripotentCells",
    "color": "#FFE523"
  },
  "mixed": {
    "componentIndex": 24,
    "active": true,
    "longName": "Mixed",
    "filenameKey": "mixed",
    "color": "#C2C2C2"
  }
};

export const componentResolutions = [
  20971520,
  10485760,
  5242880,
  2621440,
  1310720,
  655360,
  327680,
  163840,
  81920,
  40960,
  20480,
  10240,
  5120,
  2560,
  1280,
  640,
  320,
  160,
  80,
  40,
  20
];

export const componentColorMapGreyscale = [
  "rgba(255,255,255,1)",
  "rgba(0,0,0,1)"
];

export const componentColorMapViridisV1 = [
  "rgba(0,0,0,1)",
  "rgba(68,1,84,1)",
  "rgba(70,7,90,1)",
  "rgba(71,13,96,1)",
  "rgba(71,19,101,1)",
  "rgba(72,24,106,1)",
  "rgba(72,29,111,1)",
  "rgba(72,35,116,1)",
  "rgba(72,40,120,1)",
  "rgba(71,45,123,1)",
  "rgba(70,50,126,1)",
  "rgba(69,55,129,1)",
  "rgba(67,61,132,1)",
  "rgba(66,65,134,1)",
  "rgba(64,70,136,1)",
  "rgba(62,74,137,1)",
  "rgba(60,79,138,1)",
  "rgba(58,83,139,1)",
  "rgba(56,88,140,1)",
  "rgba(54,92,141,1)",
  "rgba(52,96,141,1)",
  "rgba(50,100,142,1)",
  "rgba(49,104,142,1)",
  "rgba(47,108,142,1)",
  "rgba(45,112,142,1)",
  "rgba(44,115,142,1)",
  "rgba(42,119,142,1)",
  "rgba(41,123,142,1)",
  "rgba(39,127,142,1)",
  "rgba(38,130,142,1)",
  "rgba(36,134,142,1)",
  "rgba(35,138,141,1)",
  "rgba(33,142,141,1)",
  "rgba(32,146,140,1)",
  "rgba(31,150,139,1)",
  "rgba(31,154,138,1)",
  "rgba(31,158,137,1)",
  "rgba(31,161,135,1)",
  "rgba(33,165,133,1)",
  "rgba(35,169,131,1)",
  "rgba(38,173,129,1)",
  "rgba(42,176,127,1)",
  "rgba(47,180,124,1)",
  "rgba(53,183,121,1)",
  "rgba(59,187,117,1)",
  "rgba(66,190,113,1)",
  "rgba(74,193,109,1)",
  "rgba(82,197,105,1)",
  "rgba(90,200,100,1)",
  "rgba(99,203,95,1)",
  "rgba(108,205,90,1)",
  "rgba(117,208,84,1)",
  "rgba(127,211,78,1)",
  "rgba(137,213,72,1)",
  "rgba(149,216,64,1)",
  "rgba(160,218,57,1)",
  "rgba(170,220,50,1)",
  "rgba(181,222,43,1)",
  "rgba(192,223,37,1)",
  "rgba(202,225,31,1)",
  "rgba(213,226,26,1)",
  "rgba(223,227,24,1)",
  "rgba(234,229,26,1)",
  "rgba(244,230,30,1)",
  "rgba(253,231,37,1)",
];

export const annotations = {
  "hg19" : "GENCODE v19",
  "hg38" : "GENCODE v38",
  "mm10" : "GENCODE vM21",
};

export const genomes = {
  "hg19" : "Human",
  "hg38" : "Human",
  "mm10" : "Mouse"
};

export const genomesForSettingsDrawer = {
  "Human" : ["hg19", "hg38"],
  "Mouse" : ["mm10"]
};

export const genomeNotices = {
  'hg19' : 'Chromatin state calls and 0-order background models are specific to the February 2009 human reference sequence (<em>GRCh37</em>/<em>hg19</em>), which was produced by the <a class="drawer-settings-section-body-link" href="https://www.ncbi.nlm.nih.gov/projects/genome/assembly/grc/" target="_blank">Genome Reference Consortium</a>. For more information about this assembly, see <a class="drawer-settings-section-body-link" href="https://www.ncbi.nlm.nih.gov/assembly/2758/" target="_blank">GRCh37</a> in the NCBI Assembly database.',
  'hg38' : 'Chromatin state calls and 0-order background models are specific to the December 2013 human reference sequence (<em>GRCh38</em>/<em>hg38</em>), which was produced by the <a class="drawer-settings-section-body-link" href="https://www.ncbi.nlm.nih.gov/projects/genome/assembly/grc/" target="_blank">Genome Reference Consortium</a>. State calls are derived from a liftover of hg19 calls into hg38 space (non-reciprocally-mapped regions are discarded).',
  'mm10' : 'Chromatin state calls and 0-order background models are specific to the December 2011 mouse reference sequence (<em>GRCm38</em>/<em>mm10</em>), which was produced by the <a class="drawer-settings-section-body-link" href="https://www.ncbi.nlm.nih.gov/projects/genome/assembly/grc/" target="_blank">Genome Reference Consortium</a>. Mouse state calls are obtained from the <a class="drawer-settings-section-body-link" href="http://chromosome.sdsc.edu/mouse/" target="_blank">Ren lab</a> and processed to remove call differences between sample replicates.'
};

export const defaultSingleGroupGenomeKey = "hg38";

export const defaultDrawerTabOnOpen = "proteinCodings";

export const models = {
  "15" : "15-state",
  "18" : "18-state",
  "25" : "25-state",
  "stacked" : "Stacked"
};

export const modelsForSettingsDrawer = {
  'hg19' : {
    '15' : { type:'stateModel', value:'15', text:'15-state (observed)', titleText:'15-state', enabled:true, visible:true },
    '18' : { type:'stateModel', value:'18', text:'18-state (observed, aux.)', titleText:'18-state', enabled:true, visible:true },
    '25' : { type:'stateModel', value:'25', text:'25-state (imputed)', titleText:'25-state', enabled:true, visible:true },
    'stacked' : { type:'stateModel', value:'stacked', text:'15-/18-/25-state', titleText:'15-/18-/25-state (stacked)', enabled:false, visible:false },
  },
  'hg38' : {
    '15' : { type:'stateModel', value:'15', text:'15-state (observed)', titleText:'15-state', enabled:true, visible:true },
    '18' : { type:'stateModel', value:'18', text:'18-state (observed, aux.)', titleText:'18-state', enabled:true, visible:true },
    '25' : { type:'stateModel', value:'25', text:'25-state (imputed)', titleText:'25-state', enabled:true, visible:true },
    'stacked' : { type:'stateModel', value:'stacked', text:'15-/18-/25-state', titleText:'15-/18-/25-state (stacked)', enabled:false, visible:false },
  },
  'mm10' : {
    '15' : { type:'stateModel', value:'15', text:'15-state (observed)', titleText:'15-state', enabled:true, visible:true },
    '18' : { type:'stateModel', value:'18', text:'18-state (observed, aux.)', titleText:'18-state', enabled:false, visible:false },
    '25' : { type:'stateModel', value:'25', text:'25-state (imputed)', titleText:'25-state', enabled:false, visible:false },
    'stacked' : { type:'stateModel', value:'stacked', text:'15-/18-/25-state', titleText:'15-/18-/25-state (stacked)', enabled:false, visible:false },
  }
}

export const modelNotices = {
  "hg19" : {
    "15" : "A ChromHMM model is generated from a core set of 5 chromatin marks (H3K4me3, H3K4me1, H3K36me3, H3K27me3, H3K9me3) to create a <em>15-state model</em> of mark interactions for 127 reference epigenomes (<a class=\"drawer-settings-section-body-link\" href=\"http://egg2.wustl.edu/roadmap/web_portal/chr_state_learning.html#core_15state\" target=\"_blank\">reference</a>).",
    "18" : "A ChromHMM model is generated from an expanded set of 6 chromatin marks (H3K4me3, H3K4me1, H3K36me3, H3K27me3, H3K9me3, H3K27ac) to create an <em>18-state model</em> of mark interactions for 98 reference epigenomes (<a class=\"drawer-settings-section-body-link\" href=\"http://egg2.wustl.edu/roadmap/web_portal/chr_state_learning.html#exp_18state\" target=\"_blank\">reference</a>).",
    "25" : "A ChromHMM model is generated from an expanded set of 12 chromatin marks (H3K4me1, H3K4me2, H3K4me3, H3K9ac, H3K27ac, H4K20me1, H3K79me2, H3K36me3, H3K9me3, H3K27me3, H2A.Z, and DNase) to create a <em>25-state model</em> of mark interactions for 127 reference epigenomes (<a class=\"drawer-settings-section-body-link\" href=\"http://egg2.wustl.edu/roadmap/web_portal/imputed.html#chr_imp\" target=\"_blank\">reference</a>).",
    "stacked" : "Mark interactions are rendered for <em>15-, 18-, and 25-state models</em> for this assembly."
  },
  "hg38" : {
    "15" : "A ChromHMM model is generated from a core set of 5 chromatin marks (H3K4me3, H3K4me1, H3K36me3, H3K27me3, H3K9me3) to create a <em>15-state model</em> of mark interactions for 127 reference epigenomes (<a class=\"drawer-settings-section-body-link\" href=\"http://egg2.wustl.edu/roadmap/web_portal/chr_state_learning.html#core_15state\" target=\"_blank\">reference</a>).",
    "18" : "A ChromHMM model is generated from an expanded set of 6 chromatin marks (H3K4me3, H3K4me1, H3K36me3, H3K27me3, H3K9me3, H3K27ac) to create an <em>18-state model</em> of mark interactions for 98 reference epigenomes (<a class=\"drawer-settings-section-body-link\" href=\"http://egg2.wustl.edu/roadmap/web_portal/chr_state_learning.html#exp_18state\" target=\"_blank\">reference</a>).",
    "25" : "A ChromHMM model is generated from an expanded set of 12 chromatin marks (H3K4me1, H3K4me2, H3K4me3, H3K9ac, H3K27ac, H4K20me1, H3K79me2, H3K36me3, H3K9me3, H3K27me3, H2A.Z, and DNase) to create a <em>25-state model</em> of mark interactions for 127 reference epigenomes (<a class=\"drawer-settings-section-body-link\" href=\"http://egg2.wustl.edu/roadmap/web_portal/imputed.html#chr_imp\" target=\"_blank\">reference</a>).",
    "stacked" : "Mark interactions are rendered for <em>15-, 18-, and 25-state models</em> for this assembly."
  },
  "mm10" : {
    "15" : "A ChromHMM model was generated from a core set of 5 chromatin marks (H3K4me3, H3K4me1, H3K36me3, H3K27me3, H3K9me3) to create a <em>15-state model</em> of mark interactions for 69 embryonic and day-of-birth samples."
  }
};

export const complexities = {
  "KL" : "S<sub>1</sub>",
  "KLs" : "S<sub>2</sub>",
  "KLss" : "S<sub>3</sub>",
  "stacked" : "S<sub>1,2,3</sub>"
};

export const complexitiesForDataExport = {
  "KL" : "S1",
  "KLs" : "S2",
  "KLss" : "S3",
  "stacked" : "S1_2_3"
};

export const complexitiesForSettingsDrawer = {
  'hg19' : {
    'KL' : { value:'KL', text:'KL', titleText:'S<sub>1</sub>', enabled:true, visible:true },
    'KLs' : { value:'KLs', text:'KL*', titleText:'S<sub>2</sub>', enabled:true, visible:true },
    'KLss' : { value:'KLss', text:'KL**', titleText:'S<sub>3</sub>', enabled:true, visible:true },
    'stacked' : { value:'stacked', text:'KL/KL*/KL**', titleText:'S<sub>1,2,3</sub>', enabled:false, visible:false },
  },
  'hg38' : {
    'KL' : { value:'KL', text:'KL', titleText:'S<sub>1</sub>', enabled:true, visible:true },
    'KLs' : { value:'KLs', text:'KL*', titleText:'S<sub>2</sub>', enabled:true, visible:true },
    'KLss' : { value:'KLss', text:'KL**', titleText:'S<sub>3</sub>', enabled:true, visible:true },
    'stacked' : { value:'stacked', text:'KL/KL*/KL**', titleText:'S<sub>1,2,3</sub>', enabled:false, visible:false },
  },
  'mm10' : {
    'KL' : { value:'KL', text:'KL', titleText:'S<sub>1</sub>', enabled:true, visible:true },
    'KLs' : { value:'KLs', text:'KL*', titleText:'S<sub>2</sub>', enabled:true, visible:true },
    'KLss' : { value:'KLss', text:'KL**', titleText:'S<sub>3</sub>', enabled:true, visible:true },
    'stacked' : { value:'stacked', text:'KL/KL*/KL**', titleText:'S<sub>1,2,3</sub>', enabled:false, visible:false },
  }
};

export const complexityNotices = {
  'hg19' : {
    'KL' : "<em>Level 1</em> complexity measures the saliency of a chromatin state label as relative entropy, or the information gain over a random expectation of label occurances over all biosamples.",
    'KLs' : "<em>Level 2</em> complexity measures label saliency based on co-occurance with other labels.",
    'KLss' : "<em>Level 3</em> complexity measures label saliency based on co-occurance with other labels, specific to pairs of samples.",
    'stacked' : "This selection displays complexity measurements for <em>levels 1, 2, and 3</em>."
  },
  'hg38' : {
    'KL' : "<em>Level 1</em> complexity measures the saliency of a chromatin state label as relative entropy, or the information gain over a random expectation of label occurances over all biosamples.",
    'KLs' : "<em>Level 2</em> complexity measures label saliency based on co-occurance with other labels.",
    'KLss' : "<em>Level 3</em> complexity measures label saliency based on co-occurance with other labels, specific to pairs of samples.",
    'stacked' : "This selection displays complexity measurements for <em>levels 1, 2, and 3</em>."
  },
  'mm10' : {
    'KL' : "<em>Level 1</em> complexity measures the saliency of a chromatin state label as relative entropy, or the information gain over a random expectation of label occurances over all biosamples.",
    'KLs' : "<em>Level 2</em> complexity measures label saliency based on co-occurance with other labels.",
    'KLss' : "<em>Level 3</em> complexity measures label saliency based on co-occurance with other labels, specific to pairs of samples.",
    'stacked' : "This selection displays complexity measurements for <em>levels 1, 2, and 3</em>."
  }
};

export const modes = {
  // "pw"  : "Per-component (bigWig)",
  "pc"  : "Per-component",
  "ac"  : "All",
  "co"  : "Components only",
  "cf"  : "Components only (200nt fixed bins)",
  "pm"  : "Per-component (multivec)",
  "pd"  : "Per-component, destacked (multivec)",
  "pdo" : "Per-component, destacked (multivec) -- only",
  "ft"  : "Fiberseq test",
};

export const lockPwModeVerticalScale = true;

export const modeNotices = {
  // "pw"     : 'The <em>per-component</em> viewer renders the DNase-seq signal of per-component groups of samples (bigWig datasets)',
  "pc"     : 'The <em>per-component</em> viewer renders the DNase-seq signal of per-component groups of samples',
  "ac"     : 'The <em>all-components</em> viewer renders all DNase-seq signals of all components (all samples)',
  "co"     : 'The <em>components-only</em> viewer renders the DHS Components track',
  "cf"     : 'The <em>components-only</em> viewer renders the DHS Components track (200nt fixed bins)',
  "pm"     : "The <em>per-component</em> viewer renders the DNase-seq signal of per-component groups of samples (multivec dataset)",
  "pd"     : "The <em>per-component</em> viewer renders the DNase-seq signal of per-component groups of samples in destacked form (multivec dataset)",
};

export const numSamples = {
  "raw" : "Raw DHS-in-samples count",
  "log" : "Log-transformed samples count: log(count)",
  "sst" : "Log-transformed sample specificity score: log(733-count+1)"
}

export const numSamplesNotices = {
  "raw"    : "Raw DHS-in-samples count",
  "log"    : "Log-transformed samples count: log(count)",
  "sst"    : "Log-transformed sample specificity score: log(733-count+1)"
};

export const defaultDrawerType = "proteinCodings";

export const groupsByGenome = {
  "hg19" : {
    "adult_blood_sample" : { type:"group", subtype:"single", value:"adult_blood_sample", text:"Adult Blood Sample", enabled:false, preferred: false },
    "adult_blood_reference" :  { type:"group", subtype:"single", value:"adult_blood_reference", text:"Adult Blood Reference", enabled:false, preferred: false },
    "all" : { type:"group", subtype:"single", value:"all", sortValue:"001", text:"All 127 Roadmap epigenomes", enabled:true, preferred: true },
    "Blood_T-cell" : { type:"group", subtype:"single", value:"Blood_T-cell", sortValue:"002", text:"Blood & T-cells", enabled:true, preferred: true },
    "Brain" : { type:"group", subtype:"single", value:"Brain", sortValue:"003", text:"Brain", enabled:true, preferred: true },
    "CellLine" : { type:"group", subtype:"single", value:"CellLine", text:"Cell Line", enabled:true, preferred: false },
    "cord_blood_sample" : { type:"group", subtype:"single", value:"cord_blood_sample", text:"Cord Blood Sample", enabled:false, preferred: false },
    "cord_blood_reference" : { type:"group", subtype:"single", value:"cord_blood_reference", text:"Cord Blood Reference", enabled:false, preferred: false },
    "ES-deriv" : { type:"group", subtype:"single", value:"ES-deriv", text:"ESC derived", enabled:true, preferred: false },
    "ESC" : { type:"group", subtype:"single", value:"ESC", text:"ESC", enabled:true, preferred: false },
    "Female" : { type:"group", subtype:"single", value:"Female", text:"Female donors", enabled:true, preferred: false },
    "HSC_B-cell" : { type:"group", subtype:"single", value:"HSC_B-cell", text:"HSC & B-cells", enabled:true, preferred: false },
    "iPSC" : { type:"group", subtype:"single", value:"iPSC", text:"iPSC", enabled:true, preferred: false },
    "Male" : { type:"group", subtype:"single", value:"Male", text:"Male donors", enabled:true, preferred: false },
    "Muscle" : { type:"group", subtype:"single", value:"Muscle", text:"Muscle", enabled:true, preferred: false },
    "Neurosph" : { type:"group", subtype:"single", value:"Neurosph", text:"Neurospheres", enabled:true, preferred: false },
    "Non-T-cell_Roadmap" : { type:"group", subtype:"single", value:"Non-T-cell_Roadmap", text:"Non-T-cells", enabled:true, preferred: false },
    "Other" : { type:"group", subtype:"single", value:"Other", text:"Other", enabled:true, preferred: false },
    "PrimaryCell" : { type:"group", subtype:"single", value:"PrimaryCell", text:"Primary Cell", enabled:true, preferred: false },
    "PrimaryTissue" : { type:"group", subtype:"single", value:"PrimaryTissue", text:"Primary Tissue", enabled:true, preferred: false },
    "Sm._Muscle" : { type:"group", subtype:"single", value:"Sm._Muscle", text:"Smooth Muscle", enabled:true, preferred: false },
    "ImmuneAndNeurosphCombinedIntoOneGroup" : { type:"group", subtype:"single", value:"ImmuneAndNeurosphCombinedIntoOneGroup", text:"Immune and neurosphere", enabled:true, preferred: false },
    "adult_blood_sample_vs_adult_blood_reference" : { type:"group", subtype:"paired", value:"adult_blood_sample_vs_adult_blood_reference", text:"Adult Blood Sample vs Reference", enabled:false, preferred: false },
    "Blood_T-cell_vs_Non-T-cell_Roadmap" : { type:"group", subtype:"paired", value:"Blood_T-cell_vs_Non-T-cell_Roadmap", sortValue:"002", text:"Immune vs Non-immune", enabled:true, preferred: true },
    "Brain_vs_Neurosph" : { type:"group", subtype:"paired", value:"Brain_vs_Neurosph", text:"Brain vs Neurospheres", enabled:true, preferred: false },
    "Brain_vs_Other" : { type:"group", subtype:"paired", value:"Brain_vs_Other", text:"Brain vs Other", enabled:true, preferred: false },
    "CellLine_vs_PrimaryCell" : { type:"group", subtype:"paired", value:"CellLine_vs_PrimaryCell", text:"Cell Line vs Primary Cell", enabled:true, preferred: false },
    "cord_blood_sample_vs_cord_blood_reference" : { type:"group", subtype:"paired", value:"cord_blood_sample_vs_cord_blood_reference", text:"Cord Blood Sample vs Reference", enabled:false, preferred: false },
    "ESC_vs_ES-deriv" : { type:"group", subtype:"paired", value:"ESC_vs_ES-deriv", text:"ESC vs ESC derived", enabled:true, preferred: false },
    "ESC_vs_iPSC" : { type:"group", subtype:"paired", value:"ESC_vs_iPSC", text:"ESC vs iPSC", enabled:true, preferred: false },
    "HSC_B-cell_vs_Blood_T-cell" : { type:"group", subtype:"paired", value:"HSC_B-cell_vs_Blood_T-cell", text:"HSC B-cell vs Blood T-cell", enabled:true, preferred: false },
    "Male_vs_Female" : { type:"group", subtype:"paired", value:"Male_vs_Female", sortValue:"001", text:"Male donors vs Female donors", enabled:true, preferred: true },
    "Muscle_vs_Sm._Muscle" : { type:"group", subtype:"paired", value:"Muscle_vs_Sm._Muscle", text:"Muscle vs Smooth Muscle", enabled:true, preferred: false },
    "PrimaryTissue_vs_PrimaryCell" : { type:"group", subtype:"paired", value:"PrimaryTissue_vs_PrimaryCell", sortValue:"003", text:"Primary tissue vs Primary cells", enabled:true, preferred: true },
  },
  "hg38" : {
    "adult_blood_sample" : { type:"group", subtype:"single", value:"adult_blood_sample", text:"Adult Blood Sample", enabled:false, preferred: false },
    "adult_blood_reference" :  { type:"group", subtype:"single", value:"adult_blood_reference", text:"Adult Blood Reference", enabled:false, preferred: false },
    "all" : { type:"group", subtype:"single", value:"all", sortValue:"001", text:"All 127 Roadmap epigenomes", enabled:true, preferred: true },
    "Blood_T-cell" : { type:"group", subtype:"single", value:"Blood_T-cell", sortValue:"002", text:"Blood & T-cells", enabled:true, preferred: true },
    "Brain" : { type:"group", subtype:"single", value:"Brain", sortValue:"003", text:"Brain", enabled:true, preferred: true },
    "CellLine" : { type:"group", subtype:"single", value:"CellLine", text:"Cell Line", enabled:true, preferred: false },
    "cord_blood_sample" : { type:"group", subtype:"single", value:"cord_blood_sample", text:"Cord Blood Sample", enabled:false, preferred: false },
    "cord_blood_reference" : { type:"group", subtype:"single", value:"cord_blood_reference", text:"Cord Blood Reference", enabled:false, preferred: false },
    "ES-deriv" : { type:"group", subtype:"single", value:"ES-deriv", text:"ESC derived", enabled:true, preferred: false },
    "ESC" : { type:"group", subtype:"single", value:"ESC", text:"ESC", enabled:true, preferred: false },
    "Female" : { type:"group", subtype:"single", value:"Female", text:"Female donors", enabled:true, preferred: false },
    "HSC_B-cell" : { type:"group", subtype:"single", value:"HSC_B-cell", text:"HSC & B-cells", enabled:true, preferred: false },
    "iPSC" : { type:"group", subtype:"single", value:"iPSC", text:"iPSC", enabled:true, preferred: false },
    "Male" : { type:"group", subtype:"single", value:"Male", text:"Male donors", enabled:true, preferred: false },
    "Muscle" : { type:"group", subtype:"single", value:"Muscle", text:"Muscle", enabled:true, preferred: false },
    "Neurosph" : { type:"group", subtype:"single", value:"Neurosph", text:"Neurospheres", enabled:true, preferred: false },
    "Non-T-cell_Roadmap" : { type:"group", subtype:"single", value:"Non-T-cell_Roadmap", text:"Non-T-cells", enabled:true, preferred: false },
    "Other" : { type:"group", subtype:"single", value:"Other", text:"Other", enabled:true, preferred: false },
    "PrimaryCell" : { type:"group", subtype:"single", value:"PrimaryCell", text:"Primary Cell", enabled:true, preferred: false },
    "PrimaryTissue" : { type:"group", subtype:"single", value:"PrimaryTissue", text:"Primary Tissue", enabled:true, preferred: false },
    "Sm._Muscle" : { type:"group", subtype:"single", value:"Sm._Muscle", text:"Smooth Muscle", enabled:true, preferred: false },
    "ImmuneAndNeurosphCombinedIntoOneGroup" : { type:"group", subtype:"single", value:"ImmuneAndNeurosphCombinedIntoOneGroup", text:"Immune and neurosphere", enabled:true, preferred: false },
    "adult_blood_sample_vs_adult_blood_reference" : { type:"group", subtype:"paired", value:"adult_blood_sample_vs_adult_blood_reference", text:"Adult Blood Sample vs Reference", enabled:false, preferred: false },
    "Blood_T-cell_vs_Non-T-cell_Roadmap" : { type:"group", subtype:"paired", value:"Blood_T-cell_vs_Non-T-cell_Roadmap", sortValue:"002", text:"Immune vs Non-immune", enabled:true, preferred: true },
    "Brain_vs_Neurosph" : { type:"group", subtype:"paired", value:"Brain_vs_Neurosph", text:"Brain vs Neurospheres", enabled:true, preferred: false },
    "Brain_vs_Other" : { type:"group", subtype:"paired", value:"Brain_vs_Other", text:"Brain vs Other", enabled:true, preferred: false },
    "CellLine_vs_PrimaryCell" : { type:"group", subtype:"paired", value:"CellLine_vs_PrimaryCell", text:"Cell Line vs Primary Cell", enabled:true, preferred: false },
    "cord_blood_sample_vs_cord_blood_reference" : { type:"group", subtype:"paired", value:"cord_blood_sample_vs_cord_blood_reference", text:"Cord Blood Sample vs Reference", enabled:false, preferred: false },
    "ESC_vs_ES-deriv" : { type:"group", subtype:"paired", value:"ESC_vs_ES-deriv", text:"ESC vs ESC derived", enabled:true, preferred: false },
    "ESC_vs_iPSC" : { type:"group", subtype:"paired", value:"ESC_vs_iPSC", text:"ESC vs iPSC", enabled:true, preferred: false },
    "HSC_B-cell_vs_Blood_T-cell" : { type:"group", subtype:"paired", value:"HSC_B-cell_vs_Blood_T-cell", text:"HSC B-cell vs Blood T-cell", enabled:true, preferred: false },
    "Male_vs_Female" : { type:"group", subtype:"paired", value:"Male_vs_Female", sortValue:"001", text:"Male donors vs Female donors", enabled:true, preferred: true },
    "Muscle_vs_Sm._Muscle" : { type:"group", subtype:"paired", value:"Muscle_vs_Sm._Muscle", text:"Muscle vs Smooth Muscle", enabled:true, preferred: false },
    "PrimaryTissue_vs_PrimaryCell" : { type:"group", subtype:"paired", value:"PrimaryTissue_vs_PrimaryCell", sortValue:"003", text:"Primary tissue vs Primary cells", enabled:true, preferred: true },
  },
  "mm10" : {
    "all" : { type:"group", subtype:"single", value:"all", sortValue:"001", text:"All 65 epigenomes", enabled:true, preferred: true },
    "digestiveSystem" : { type:"group", subtype:"single", value:"digestiveSystem", sortValue:"002", text:"Digestive System", enabled:true, preferred: true },
    "e11.5" : { type:"group", subtype:"single", value:"e11.5", sortValue:"003", text:"Embryonic day 11.5", enabled:true, preferred: true },
    "e11.5_vs_P0" : { type:"group", subtype:"paired", value:"e11.5_vs_P0", text:"Embryonic day 11.5 vs Day-of-birth", enabled:true, preferred: true },
    "e12.5" : { type:"group", subtype:"single", value:"e12.5", text:"Embryonic day 12.5", enabled:true, preferred: false },
    "e13.5" : { type:"group", subtype:"single", value:"e13.5", text:"Embryonic day 13.5", enabled:true, preferred: false },
    "e14.5" : { type:"group", subtype:"single", value:"e14.5", text:"Embryonic day 14.5", enabled:true, preferred: false },
    "e15.5" : { type:"group", subtype:"single", value:"e15.5", text:"Embryonic day 15.5", enabled:true, preferred: false },
    "e16.5" : { type:"group", subtype:"single", value:"e16.5", text:"Embryonic day 16.5", enabled:false, preferred: false },
    "facial-prominence" : { type:"group", subtype:"single", value:"facial-prominence", text:"Facial prominence", enabled:true, preferred: false },
    "forebrain" : { type:"group", subtype:"single", value:"forebrain", text:"Forebrain", enabled:true, preferred: false },
    "forebrain_vs_hindbrain" : { type:"group", subtype:"paired", value:"forebrain_vs_hindbrain", text:"Forebrain vs Hindbrain", enabled:true, preferred: true },
    "heart" : { type:"group", subtype:"single", value:"heart", text:"Heart", enabled:true, preferred: false },
    "hindbrain" : { type:"group", subtype:"single", value:"hindbrain", text:"Hindbrain", enabled:true, preferred: false },
    "intestine" : { type:"group", subtype:"single", value:"intestine", text:"Intestine", enabled:true, preferred: false },
    "kidney" : { type:"group", subtype:"single", value:"kidney", text:"Kidney", enabled:true, preferred: false },
    "limb" : { type:"group", subtype:"single", value:"limb", text:"Limb", enabled:true, preferred: false },
    "liver" : { type:"group", subtype:"single", value:"liver", text:"Liver", enabled:true, preferred: false },
    "lung" : { type:"group", subtype:"single", value:"lung", text:"Lung", enabled:true, preferred: false },
    "neural-tube" : { type:"group", subtype:"single", value:"neural-tube", text:"Neural Tube", enabled:true, preferred: false },
    "P0" : { type:"group", subtype:"single", value:"P0", sortValue:"004", text:"Day-of-birth", enabled:true, preferred: true },
    "stomach" : { type:"group", subtype:"single", value:"stomach", text:"Stomach", enabled:true, preferred: false },
  }
};

export const defaultSingleGroupKeys = {
  "hg19" : "all",
  "hg38" : "all",
  "mm10" : "all"
};

export const defaultPairedGroupKeys = {
  "hg19" : "Male_vs_Female",
  "hg38" : "Male_vs_Female",
  "mm10" : "e11.5_vs_P0"
};

export const defaultSingleModelKeys = {
  "hg19" : "15",
  "hg38" : "15",
  "mm10" : "15"
};

export const defaultPairedModelKeys = {
  "hg19" : "15",
  "hg38" : "15",
  "mm10" : "15"
};

export const defaultSingleComplexityKeys = {
  "hg19" : "KL",
  "hg38" : "KL",
  "mm10" : "KL"
};

export const defaultPairedComplexityKeys = {
  "hg19" : "KL",
  "hg38" : "KL",
  "mm10" : "KL"
};

//
// Chromosomes
//

export const chromInfo = {
  'hg38': {
    "cumPositions" : [
      {
        "id" : 0,
        "chr" : "chr1",
        "pos" : 0
      },
      {
        "id" : 1,
        "chr" : "chr2",
        "pos" : 248956422
      },
      {
        "id" : 2,
        "chr" : "chr3",
        "pos" : 491149951
      },
      {
        "id" : 3,
        "chr" : "chr4",
        "pos" : 689445510
      },
      {
        "id" : 4,
        "chr" : "chr5",
        "pos" : 879660065
      },
      {
        "id" : 5,
        "chr" : "chr6",
        "pos" : 1061198324
      },
      {
        "id" : 6,
        "chr" : "chr7",
        "pos" : 1232004303
      },
      {
        "id" : 7,
        "chr" : "chr8",
        "pos" : 1391350276
      },
      {
        "id" : 8,
        "chr" : "chr9",
        "pos" : 1536488912
      },
      {
        "id" : 9,
        "chr" : "chr10",
        "pos" : 1674883629
      },
      {
        "id" : 10,
        "chr" : "chr11",
        "pos" : 1808681051
      },
      {
        "id" : 11,
        "chr" : "chr12",
        "pos" : 1943767673
      },
      {
        "id" : 12,
        "chr" : "chr13",
        "pos" : 2077042982
      },
      {
        "id" : 13,
        "chr" : "chr14",
        "pos" : 2191407310
      },
      {
        "id" : 14,
        "chr" : "chr15",
        "pos" : 2298451028
      },
      {
        "id" : 15,
        "chr" : "chr16",
        "pos" : 2400442217
      },
      {
        "id" : 16,
        "chr" : "chr17",
        "pos" : 2490780562
      },
      {
        "id" : 17,
        "chr" : "chr18",
        "pos" : 2574038003
      },
      {
        "id" : 18,
        "chr" : "chr19",
        "pos" : 2654411288
      },
      {
        "id" : 19,
        "chr" : "chr20",
        "pos" : 2713028904
      },
      {
        "id" : 20,
        "chr" : "chr21",
        "pos" : 2777473071
      },
      {
        "id" : 21,
        "chr" : "chr22",
        "pos" : 2824183054
      },
      {
        "id" : 22,
        "chr" : "chrX",
        "pos" : 2875001522
      },
      {
        "id" : 23,
        "chr" : "chrY",
        "pos" : 3031042417
      }
    ],
    "chrPositions" : {
      "chr1" : {
        "id" : 0,
        "chr" : "chr1",
        "pos" : 0
      },
      "chr2" : {
        "id" : 1,
        "chr" : "chr2",
        "pos" : 248956422
      },
      "chr3" : {
        "id" : 2,
        "chr" : "chr3",
        "pos" : 491149951
      },
      "chr4" : {
        "id" : 3,
        "chr" : "chr4",
        "pos" : 689445510
      },
      "chr5" : {
        "id" : 4,
        "chr" : "chr5",
        "pos" : 879660065
      },
      "chr6" : {
        "id" : 5,
        "chr" : "chr6",
        "pos" : 1061198324
      },
      "chr7" : {
        "id" : 6,
        "chr" : "chr7",
        "pos" : 1232004303
      },
      "chr8" : {
        "id" : 7,
        "chr" : "chr8",
        "pos" : 1391350276
      },
      "chr9" : {
        "id" : 8,
        "chr" : "chr9",
        "pos" : 1536488912
      },
      "chr10" : {
        "id" : 9,
        "chr" : "chr10",
        "pos" : 1674883629
      },
      "chr11" : {
        "id" : 10,
        "chr" : "chr11",
        "pos" : 1808681051
      },
      "chr12" : {
        "id" : 11,
        "chr" : "chr12",
        "pos" : 1943767673
      },
      "chr13" : {
        "id" : 12,
        "chr" : "chr13",
        "pos" : 2077042982
      },
      "chr14" : {
        "id" : 13,
        "chr" : "chr14",
        "pos" : 2191407310
      },
      "chr15" : {
        "id" : 14,
        "chr" : "chr15",
        "pos" : 2298451028
      },
      "chr16" : {
        "id" : 15,
        "chr" : "chr16",
        "pos" : 2400442217
      },
      "chr17" : {
        "id" : 16,
        "chr" : "chr17",
        "pos" : 2490780562
      },
      "chr18" : {
        "id" : 17,
        "chr" : "chr18",
        "pos" : 2574038003
      },
      "chr19" : {
        "id" : 18,
        "chr" : "chr19",
        "pos" : 2654411288
      },
      "chr20" : {
        "id" : 19,
        "chr" : "chr20",
        "pos" : 2713028904
      },
      "chr21" : {
        "id" : 20,
        "chr" : "chr21",
        "pos" : 2777473071
      },
      "chr22" : {
        "id" : 21,
        "chr" : "chr22",
        "pos" : 2824183054
      },
      "chrX" : {
        "id" : 22,
        "chr" : "chrX",
        "pos" : 2875001522
      },
      "chrY" : {
        "id" : 23,
        "chr" : "chrY",
        "pos" : 3031042417
      }
    },
    "totalLength" : 3088269832,
    "chromLengths" : {
      "chr1" : 248956422,
      "chr2" : 242193529,
      "chr3" : 198295559,
      "chr4" : 190214555,
      "chr5" : 181538259,
      "chr6" : 170805979,
      "chr7" : 159345973,
      "chr8" : 145138636,
      "chr9" : 138394717,
      "chr10" : 133797422,
      "chr11" : 135086622,
      "chr12" : 133275309,
      "chr13" : 114364328,
      "chr14" : 107043718,
      "chr15" : 101991189,
      "chr16" : 90338345,
      "chr17" : 83257441,
      "chr18" : 80373285,
      "chr19" : 58617616,
      "chr20" : 64444167,
      "chr21" : 46709983,
      "chr22" : 50818468,
      "chrX" : 156040895,
      "chrY" : 57227415
    }
  }
};

export const assemblyChromosomes = {
  'hg19':[
    'chr1', 'chr2', 'chr3', 'chr4', 'chr5', 'chr6', 'chr7', 'chr8', 'chr9', 'chr10', 'chr11', 'chr12', 'chr13', 'chr14', 'chr15', 'chr16', 'chr17', 'chr18', 'chr19', 'chr20', 'chr21', 'chr22', 'chrX', 'chrY'
  ],
  'hg38':[
    'chr1', 'chr2', 'chr3', 'chr4', 'chr5', 'chr6', 'chr7', 'chr8', 'chr9', 'chr10', 'chr11', 'chr12', 'chr13', 'chr14', 'chr15', 'chr16', 'chr17', 'chr18', 'chr19', 'chr20', 'chr21', 'chr22', 'chrX', 'chrY'
  ],
  'mm10':[
    'chr1', 'chr2', 'chr3', 'chr4', 'chr5', 'chr6', 'chr7', 'chr8', 'chr9', 'chr10', 'chr11', 'chr12', 'chr13', 'chr14', 'chr15', 'chr16', 'chr17', 'chr18', 'chr19', 'chrX', 'chrY'
  ]
};

export const assemblyBounds = {
  'hg19':{
    'chr1':{'ub':249250621},
    'chr2':{'ub':243199373},
    'chr3':{'ub':198022430},
    'chr4':{'ub':191154276},
    'chr5':{'ub':180915260},
    'chr6':{'ub':171115067},
    'chr7':{'ub':159138663},
    'chr8':{'ub':146364022},
    'chr9':{'ub':141213431},
    'chr10':{'ub':135534747},
    'chr11':{'ub':135006516},
    'chr12':{'ub':133851895},
    'chr13':{'ub':115169878},
    'chr14':{'ub':107349540},
    'chr15':{'ub':102531392},
    'chr16':{'ub':90354753},
    'chr17':{'ub':81195210},
    'chr18':{'ub':78077248},
    'chr19':{'ub':59128983},
    'chr20':{'ub':63025520},
    'chr22':{'ub':51304566},
    'chr21':{'ub':48129895},
    'chrX':{'ub':155270560},
    'chrY':{'ub':59373566},
  },
  'hg38':{
    'chr1':{'ub':248956422},
    'chr10':{'ub':133797422},
    'chr11':{'ub':135086622},
    'chr12':{'ub':133275309},
    'chr13':{'ub':114364328},
    'chr14':{'ub':107043718},
    'chr15':{'ub':101991189}, 
    'chr16':{'ub':90338345},
    'chr17':{'ub':83257441},
    'chr18':{'ub':80373285},
    'chr19':{'ub':58617616},
    'chr2':{'ub':242193529},
    'chr20':{'ub':64444167},
    'chr21':{'ub':46709983},
    'chr22':{'ub':50818468},
    'chr3':{'ub':198295559},
    'chr4':{'ub':190214555},
    'chr5':{'ub':181538259},
    'chr6':{'ub':170805979},
    'chr7':{'ub':159345973},
    'chr8':{'ub':145138636},
    'chr9':{'ub':138394717},
    'chrX':{'ub':156040895},
    'chrY':{'ub':57227415},
  },
  'mm10':{
    'chr1':{'ub':195471971},
    'chr10':{'ub':130694993},
    'chr11':{'ub':122082543},
    'chr12':{'ub':120129022},
    'chr13':{'ub':120421639},
    'chr14':{'ub':124902244},
    'chr15':{'ub':104043685},
    'chr16':{'ub':98207768},
    'chr17':{'ub':94987271},
    'chr18':{'ub':90702639},
    'chr19':{'ub':61431566},
    'chr2':{'ub':182113224},
    'chr3':{'ub':160039680},
    'chr4':{'ub':156508116},
    'chr5':{'ub':151834684},
    'chr6':{'ub':149736546},
    'chr7':{'ub':145441459},
    'chr8':{'ub':129401213},
    'chr9':{'ub':124595110},
    'chrX':{'ub':171031299},
    'chrY':{'ub':91744698},
  },
};

//
// System color palettes
//

export const systemColorPalettes = {
  'hg38' : {
    "placentalTrophoblast" : "255,229,0",
    "lymphoid" : "254,129,2",
    "myeloidErythroid" : "255,0,0",
    "cardiac" : "7,175,0",
    "musculoskeletal" : "76,125,20",
    "vascularEndothelial" : "65,70,19",
    "primitiveEmbryonic" : "5,193,217",
    "neural" : "4,103,253",
    "digestive" : "0,149,136",
    "stromalA" : "187,45,212",
    "stromalB" : "122,0,255",
    "renalCancer" : "74,104,118",
    "cancerEpithelial" : "8,36,91",
    "pulmonaryDevelopment" : "185,70,29",
    "organDevelopmentRenal" : "105,33,8",
    "tissueInvariant" : "195,195,195"
  }
};

export const systemColorPalettesAsHex = {
  "hg38" : {
    "16" : [
      "#ffe600",
      "#ff8203",
      "#ff0000",
      "#05b000",
      "#4c7d14",
      "#404513",
      "#04c0d9",
      "#0568fc",
      "#009488",
      "#bb2cd4",
      "#7a00ff",
      "#4a6775",
      "#08265c",
      "#ba471e",
      "#691f08",
      "#c2c2c2",
    ],
    "24" : {
      "original": [
        "#f0f8ff",
        "#d3d3d3",
        "#ffebcd",
        "#8b4513",
        "#ffdab9",
        "#fff0f5",
        "#d2691e",
        "#f4a460",
        "#08245b",
        "#ff0000",
        "#414613",
        "#009588",
        "#4c7d14",
        "#b9461d",
        "#692108",
        "#07af00",
        "#0467fd",
        "#ffe500",
        "#4a6876",
        "#fe8102",
        "#7a00ff",
        "#05c1d9",
        "#bb2dd4",
        "#c3c3c3",
      ],
      "011924" : [
        "#bb2dd4",
        "#e6009b",
        "#b8461b",
        "#e6550d",
        "#fd8d3c",
        "#fbb571",
        "#fed4de",
        "#ed2024",
        "#ae1618",
        "#92171a",
        "#8cc63f",
        "#dde223",
        "#37c1f1",
        "#2e97bc",
        "#207593",
        "#105986",
        "#00ad95",
        "#526e7d",
        "#ffdab9",
        "#6b54a3",
        "#2c674a",
        "#2c924a",
        "#ffe523",
        "#c2c2c2",
      ],
    },
    "29" : {
      "042924" : [
        "#BB2DD4",
        "#E6009B",
        "#FFDE00",
        "#FF7600",
        "#ED2024",
        "#AE1618",
        "#414613",
        "#32A63A",
        "#3BE796",
        "#00AD95",
        "#4A6876",
        "#08245B",
        "#0479FD",
        "#37C1F1",
        "#A1EFFF",
        "#45316B",
        "#6B54A3",
        "#759CD5",
        "#FEF3BB",
        "#FFDAB9",
        "#FFC26A",
        "#D0D2F8",
        "#C2FFED",
        "#C2FF99",
        "#8CC63F",
        "#D48EB8",
        "#FF9BC7",
        "#FFABF1",
        "#E7E9E9",
      ],
    },
  },
};

export const systemHumanReadableNames = {
  'hg38' : {
    "placentalTrophoblast" : "Placental & trophoblast",
    "lymphoid" : "Lymphoid",
    "myeloidErythroid" : "Myeloid & erythroid",
    "cardiac" : "Cardiac",
    "musculoskeletal" : "Musculoskeletal",
    "vascularEndothelial" : "Vascular & endothelial",
    "primitiveEmbryonic" : "Primitive & embryonic",
    "neural" : "Neural",
    "digestive" : "Digestive",
    "stromalA" : "Stromal A",
    "stromalB" : "Stromal B",
    "renalCancer" : "Renal & cancer",
    "cancerEpithelial" : "Cancer & epithelial",
    "pulmonaryDevelopment" : "Pulmonary devel.",
    "organDevelopmentRenal" : "Organ devel. & renal",
    "tissueInvariant" : "Tissue invariant"
  }
};

//
// State color palettes
// 

export const stateColorPalettes = {
  'hg19' : {
    15 : {
      1:['Active TSS','#ff0000'],
      2:['Flanking Active TSS','#ff4500'],
      3:['Transcr at gene 5\' and 3\'','#32cd32'],
      4:['Strong transcription','#008000'],
      5:['Weak transcription','#006400'],
      6:['Genic enhancers','#c2e105'],
      7:['Enhancers','#ffff00'],
      8:['ZNF genes + repeats','#66cdaa'],
      9:['Heterochromatin','#8a91d0'],
      10:['Bivalent/Poised TSS','#cd5c5c'],
      11:['Flanking Bivalent TSS/Enh','#e9967a'],
      12:['Bivalent Enhancer','#bdb76b'],
      13:['Repressed PolyComb','#808080'],
      14:['Weak Repressed PolyComb','#c0c0c0'],
      15:['Quiescent/Low','#ffffff']
    },
    18 : {
      1:['Active TSS','#ff0000'],
      2:['Flanking TSS','#ff4500'],
      3:['Flanking TSS Upstream','#ff4500'],
      4:['Flanking TSS Downstream','#ff4500'],
      5:['Strong transcription','#008000'],
      6:['Weak transcription','#006400'],
      7:['Genic enhancer 1','#c2e105'],
      8:['Genic enhancer 2','#c2e105'],
      9:['Active Enhancer 1','#ffc34d'],
      10:['Active Enhancer 2','#ffc34d'],
      11:['Weak Enhancer','#ffff00'],
      12:['ZNF genes + repeats','#66cdaa'],
      13:['Heterochromatin','#8a91d0'],
      14:['Bivalent/Poised TSS','#cd5c5c'],
      15:['Bivalent Enhancer','#bdb76b'],
      16:['Repressed PolyComb','#808080'],
      17:['Weak Repressed PolyComb','#c0c0c0'],
      18:['Quiescent/Low','#ffffff']
    },
    25 : {
      1:['Active TSS','#ff0000'],
      2:['Promoter Upstream TSS','#ff4500'],
      3:['Promoter Downstream TSS with DNase','#ff4500'],
      4:['Promoter Downstream TSS','#ff4500'],
      5:['Transcription 5\'','#008000'],
      6:['Transcription','#008000'],
      7:['Transcription 3\'','#008000'],
      8:['Weak transcription','#009600'],
      9:['Transcription Regulatory','#c2e105'],
      10:['Transcription 5\' Enhancer','#c2e105'],
      11:['Transcription 3\' Enhancer','#c2e105'],
      12:['Transcription Weak Enhancer','#c2e105'],
      13:['Active Enhancer 1','#ffc34d'],
      14:['Active Enhancer 2','#ffc34d'],
      15:['Active Enhancer Flank','#ffc34d'],
      16:['Weak Enhancer 1','#ffff00'],
      17:['Weak Enhancer 2','#ffff00'],
      18:['Enhancer Acetylation Only','#ffff00'],
      19:['DNase only','#ffff66'],
      20:['ZNF genes + repeats','#66cdaa'],
      21:['Heterochromatin','#8a91d0'],
      22:['Poised Promoter','#e6b8b7'],
      23:['Bivalent Promoter','#7030a0'],
      24:['Repressed PolyComb','#808080'],
      25:['Quiescent/Low','#ffffff']
    }
  },
  'hg38':{
    15 : {
      1:['Active TSS','#ff0000'],
      2:['Flanking Active TSS','#ff4500'],
      3:['Transcr at gene 5\' and 3\'','#32cd32'],
      4:['Strong transcription','#008000'],
      5:['Weak transcription','#006400'],
      6:['Genic enhancers','#c2e105'],
      7:['Enhancers','#ffff00'],
      8:['ZNF genes + repeats','#66cdaa'],
      9:['Heterochromatin','#8a91d0'],
      10:['Bivalent/Poised TSS','#cd5c5c'],
      11:['Flanking Bivalent TSS/Enh','#e9967a'],
      12:['Bivalent Enhancer','#bdb76b'],
      13:['Repressed PolyComb','#808080'],
      14:['Weak Repressed PolyComb','#c0c0c0'],
      15:['Quiescent/Low','#ffffff']
    },
    18 : {
      1:['Active TSS','#ff0000'],
      2:['Flanking TSS','#ff4500'],
      3:['Flanking TSS Upstream','#ff4500'],
      4:['Flanking TSS Downstream','#ff4500'],
      5:['Strong transcription','#008000'],
      6:['Weak transcription','#006400'],
      7:['Genic enhancer 1','#c2e105'],
      8:['Genic enhancer 2','#c2e105'],
      9:['Active Enhancer 1','#ffc34d'],
      10:['Active Enhancer 2','#ffc34d'],
      11:['Weak Enhancer','#ffff00'],
      12:['ZNF genes + repeats','#66cdaa'],
      13:['Heterochromatin','#8a91d0'],
      14:['Bivalent/Poised TSS','#cd5c5c'],
      15:['Bivalent Enhancer','#bdb76b'],
      16:['Repressed PolyComb','#808080'],
      17:['Weak Repressed PolyComb','#c0c0c0'],
      18:['Quiescent/Low','#ffffff']
    },
    25 : {
      1:['Active TSS','#ff0000'],
      2:['Promoter Upstream TSS','#ff4500'],
      3:['Promoter Downstream TSS with DNase','#ff4500'],
      4:['Promoter Downstream TSS','#ff4500'],
      5:['Transcription 5\'','#008000'],
      6:['Transcription','#008000'],
      7:['Transcription 3\'','#008000'],
      8:['Weak transcription','#009600'],
      9:['Transcription Regulatory','#c2e105'],
      10:['Transcription 5\' Enhancer','#c2e105'],
      11:['Transcription 3\' Enhancer','#c2e105'],
      12:['Transcription Weak Enhancer','#c2e105'],
      13:['Active Enhancer 1','#ffc34d'],
      14:['Active Enhancer 2','#ffc34d'],
      15:['Active Enhancer Flank','#ffc34d'],
      16:['Weak Enhancer 1','#ffff00'],
      17:['Weak Enhancer 2','#ffff00'],
      18:['Enhancer Acetylation Only','#ffff00'],
      19:['DNase only','#ffff66'],
      20:['ZNF genes + repeats','#66cdaa'],
      21:['Heterochromatin','#8a91d0'],
      22:['Poised Promoter','#e6b8b7'],
      23:['Bivalent Promoter','#7030a0'],
      24:['Repressed PolyComb','#808080'],
      25:['Quiescent/Low','#ffffff']
    }
  },
  'mm10':{
    15 : {
      1:['Promoter - Active','#0e6f37'], 
      2:['Promoter - Weak/Inactive','#c7e4c0'], 
      3:['Promoter - Bivalent','#cdcdcd'], 
      4:['Promoter - Flanking','#41ac5e'], 
      5:['Enhancer - Strong, TSS-distal','#f3eb1a'], 
      6:['Enhancer - Strong, TSS-proximal','#f3eb1a'], 
      7:['Enhancer - Weak, TSS-distal','#faf8c8'], 
      8:['Enhancer - Poised, TSS-distal','#808080'], 
      9:['Enhancer - Poised, TSS-proximal','#808080'], 
      10:['Transcription - Strong','#0454a3'], 
      11:['Transcription - Permissive','#deecf7'], 
      12:['Transcription - Initiation','#4290cf'], 
      13:['Heterochromatin - Polycomb','#f48c8f'], 
      14:['Heterochromatin - H3K9me3','#fde2e5'], 
      15:['No signal','#ffffff']
    }
  },
};

export const viewerHgViewconfColormapsPatchedForDuplicates = {
  'hg19' : {
    '15' : [
      '#ff0000',
      '#ff4500',
      '#32cd32',
      '#008000',
      '#006400',
      '#c2e105',
      '#ffff00',
      '#66cdaa',
      '#8a91d0',
      '#cd5c5c',
      '#e9967a',
      '#bdb76b',
      '#808080',
      '#c0c0c0',
      '#ffffff'
    ],
    '18' : [
      '#ff0000',
      '#ff4500',
      '#ff4501',
      '#ff4502',
      '#008000',
      '#006400',
      '#c2e105',
      '#c2e106',
      '#ffc34d',
      '#ffc34e',
      '#ffff00',
      '#66cdaa',
      '#8a91d0',
      '#cd5c5c',
      '#bdb76b',
      '#808080',
      '#c0c0c0',
      '#ffffff',
    ],
    '25' : [
      '#ff0000',
      '#ff4500',
      '#ff4501',
      '#ff4502',
      '#008000',
      '#008001',
      '#008002',
      '#009600',
      '#c2e105',
      '#c2e106',
      '#c2e107',
      '#c2e108',
      '#ffc34d',
      '#ffc34e',
      '#ffc34f',
      '#ffff00',
      '#ffff01',
      '#ffff02',
      '#ffff66',
      '#66cdaa',
      '#8a91d0',
      '#e6b8b7',
      '#7030a0',
      '#808080',
      '#ffffff',
    ]
  },
  'hg38' : {
    '15' : [
      '#ff0000',
      '#ff4500',
      '#32cd32',
      '#008000',
      '#006400',
      '#c2e105',
      '#ffff00',
      '#66cdaa',
      '#8a91d0',
      '#cd5c5c',
      '#e9967a',
      '#bdb76b',
      '#808080',
      '#c0c0c0',
      '#ffffff'
    ],
    '18' : [
      '#ff0000',
      '#ff4500',
      '#ff4501',
      '#ff4502',
      '#008000',
      '#006400',
      '#c2e105',
      '#c2e106',
      '#ffc34d',
      '#ffc34e',
      '#ffff00',
      '#66cdaa',
      '#8a91d0',
      '#cd5c5c',
      '#bdb76b',
      '#808080',
      '#c0c0c0',
      '#ffffff',
    ],
    '25' : [
      '#ff0000',
      '#ff4500',
      '#ff4501',
      '#ff4502',
      '#008000',
      '#008001',
      '#008002',
      '#009600',
      '#c2e105',
      '#c2e106',
      '#c2e107',
      '#c2e108',
      '#ffc34d',
      '#ffc34e',
      '#ffc34f',
      '#ffff00',
      '#ffff01',
      '#ffff02',
      '#ffff66',
      '#66cdaa',
      '#8a91d0',
      '#e6b8b7',
      '#7030a0',
      '#808080',
      '#ffffff',
    ]
  },
  'mm10' : {
    '15' : [
      '#0e6f37',
      '#c7e4c0',
      '#cdcdcd',
      '#41ac5e',
      '#f3eb1a',
      '#f3eb1b',
      '#faf8c8',
      '#808080',
      '#808081',
      '#0454a3',
      '#deecf7',
      '#4290cf',
      '#f48c8f',
      '#fde2e5',
      '#ffffff',
    ]
  }
}

//
// Portal
//

/**
  $ pwd
  /home/ubuntu/index/public/assets/exemplars/hg38
  $ cat <(cut -f4 proteinCodings/top15PerSystem.txt) <(cut -f4 transcriptionFactors/top15PerSystem.txt) | awk '{printf("\"%s\", ", $1)}'
**/
export const portalGenes = ["CNKSR1", "C5orf45", "RDH13", "CTRC", "KCNK16", "SLC6A19", "AHSA1", "INTS11", "BABAM1", "CLCNKB", "FAM71A", "PDE4C", "WRAP73", "KCNH4", "SEPT12", "USP41", "ADIPOQ", "PRAMEF12", "GPX6", "SCGB1D1", "OR2Z1", "C16orf78", "AC114783.1", "ACCSL", "LRRC18", "KRT73", "C1QL2", "TBC1D29", "LACRT", "F10", "MAPK15", "CNTROB", "AC009336.19", "C1QTNF12", "FRMD1", "RP11-523H20.5", "CARD9", "SLC45A4", "SSTR3", "LACTBL1", "PDCD6", "CRB2", "FLRT1", "KLK14", "NPR2", "DCN", "ADH1B", "PSD2", "CSN3", "SMYD5", "FAM162B", "RSPO2", "ASPA", "SPATA22", "CCDC154", "FGF10", "ERLEC1", "DHCR7", "C9orf116", "OR2A2", "HLA-DQA1", "SELL", "CD48", "OR4C15", "FCER2", "TCL1A", "ICOS", "ASTL", "POLR1C", "RP11-80H18.3", "CTLA4", "GCSAM", "PDE6H", "OR2G6", "TIGIT", "TFRC", "IL9R", "LMO2", "HEMGN", "GYPA", "RABGGTB", "GYPB", "MPO", "ALAS2", "TRIM58", "GYPE", "HBD", "HBB", "MDM2", "ERAL1", "PLN", "RBM24", "POPDC2", "KRTAP19-1", "COX17", "RHOQ", "APOBEC2", "MYH6", "LDB3", "HRH2", "MYH7", "TNNT2", "TECRL", "HUS1B", "ACTN2", "SHPK", "GPS1", "TNXB", "NRBP2", "MTHFSD", "BAP1", "MOB2", "RP11-235E17.2", "MFRP", "C20orf27", "HDAC11", "AC027601.2", "DNAH1", "REM1", "ACAP1", "TXNDC5", "PXDC1", "CAV1", "EGFL7", "SDPR", "ANKRD1", "FAM124B", "BLOC1S5-TXNDC5", "CALCRL", "TGM2", "HRG", "TLR4", "PALMD", "GIMAP7", "CAPZA2", "C1orf61", "AMER2", "CDKN2B", "GABRA6", "GABRA1", "CALB1", "TCEAL6", "LRRC3B", "RP3-336H9.2", "DIRAS2", "GPM6A", "C18orf42", "KCNJ3", "SLC17A6", "GABRG2", "FABP1", "EREG", "RBP2", "NMUR2", "ALDOB", "PRR15L", "SPINK1", "RNF128", "SLC34A3", "CDC7", "CEACAM18", "MUC20", "UPK3A", "PCK1", "OCLN", "KRT7", "ACSM5", "ZBED6CL", "C1GALT1", "PLK2", "TAF9B", "UGCG", "HAVCR1", "C1orf186", "LDHA", "LRRC61", "SPP1", "EGLN3", "RP11-977G19.10", "GUCA1C", "SERPINB5", "TUBE1", "INTS2", "MUC16", "NLRP4", "FAM229B", "CINP", "RPE65", "SETD1A", "OR1I1", "KRT14", "OR10H3", "SERPINB2", "ACADM", "ASAH2", "USP15", "SLC35E3", "WASHC4", "CDK17", "BRI3BP", "SENP1", "KRT79", "HAL", "RAB28", "HTR1D", "IPO5", "TMEM117", "CPM", "UBE3B", "CCER1", "COL1A2", "COL1A1", "FN1", "COL3A1", "GREM1", "SPARC", "ERRFI1", "RND3", "RGMB", "SERPINE1", "PTX3", "POLR2B", "NNMT", "ARL5B", "PTGFR", "MED28", "H2AFZ", "PRSS27", "HAUS4", "OR2V1", "C19orf47", "MARCKS", "SETD9", "CXorf40B", "MADD", "PRR3", "TTC32", "CDCA8", "SRSF8", "SLC36A4", "DPRX", "GCM1", "ZNF354B", "E4F1", "PRR12", "KMT2B", "MBD3", "IRF3", "NRL", "ZNF165", "MYPOP", "FOXR1", "MAFF", "ATF3", "ZSCAN4", "NR2E1", "ZNF551", "HMX1", "ONECUT3", "KLF17", "HOXD13", "TRAFD1", "NKX2-6", "HIC2", "ZNF488", "NEUROG3", "GBX1", "TBX21", "MNX1", "ZNF333", "HOXD3", "HOXB9", "HOXC4", "NR2F1", "HOXC10", "HOXA2", "HOXB8", "ZNF574", "HOXD4", "HOXA3", "ZNF835", "SCX", "SALL1", "HOXD9", "NR2F2", "HOXB3", "HOXB5", "PRDM6", "FOXF2", "MAF", "DACH1", "ZNF503", "NFXL1", "RFX6", "GLIS3", "FOXP2", "ZNF385B", "ZFHX3", "SOX5", "MKX", "FOXP3", "ZNF14", "USF1", "ZGPAT", "ZNF107", "ZBTB32", "MEF2B", "ZNF334", "IKZF1", "SPIB", "ZNF512", "PROP1", "ZNF414", "RELB", "CPXCR1", "GATA1", "NFE2", "ZNF248", "YBX1", "MYB", "GFI1B", "CARF", "ZFPM1", "ZSCAN16", "BACH1", "ZNF556", "E2F3", "NAIF1", "LYL1", "PRMT3", "GATA6", "TBX20", "GATA4", "HEY2", "HAND2", "PROX1", "VEZF1", "ZNF76", "NKX2-5", "MEIS2", "MEF2A", "CREM", "ZNF728", "RARB", "MEIS1", "AIRE", "CIC", "ZBTB9", "SAFB2", "KLF15", "NFATC2", "EBF2", "TSHZ3", "EBF3", "ZNF362", "SHOX", "ZNF646", "PBX2", "MYT1", "GLI2", "ELK3", "SOX18", "ZNF366", "ERG", "MECOM", "SMAD9", "ZNF71", "NFATC1", "L3MBTL3", "FOXO1", "FLI1", "ZNF521", "AHR", "NFIA", "CREB1", "TFAP2B", "POU4F2", "NKX6-2", "POU3F4", "ZIC3", "VSX2", "FOXG1", "OTP", "NEUROD6", "EN2", "NHLH2", "ISL1", "NEUROD1", "PRDM8", "DLX6", "HNF4G", "KLF5", "ELF3", "EHF", "CDX2", "HNF1B", "ZNF506", "HNF4A", "ZNF223", "PPARA", "NR1I2", "PLAGL2", "HNF1A", "ARID3A", "BARX2", "FOSL2", "PAX8", "STAT1", "MAFG", "HOXB7", "ZNF25", "MITF", "FOSL1", "ZKSCAN3", "ZNF395", "ZFP2", "TFCP2L1", "TERF1", "NFE2L3", "TBX15", "ZNF274", "GTF2B", "IRF6", "ZNF460", "ZNF613", "SPDEF", "HSF2", "SPI1", "ZNF227", "MEOX2", "TCFL5", "ATF2", "NOBOX", "POU6F2", "ZNF623", "ZNF605", "CUX2", "HMGA2", "PHF20", "TWIST2", "PRRX1", "HIF1A", "IRX2", "BNC2", "CLOCK", "TRPS1", "TCF4", "AR", "RUNX2", "SNAI2", "ZNF410", "TCF12", "BBX", "PRRX2", "ZNF134", "CEBPD", "ZNF616", "ZBTB14", "ZBED3", "ZBED5", "ZNF880", "ZNF790", "ZNF540", "MYNN", "THAP5", "ZNF382", "TOPORS", "MYC", "PEG3"];

export const portalHgViewParameters = {
  "genome": "hg38",
  "model": "15",
  "complexity": "KL",
  "group": "all",
  "mode": "pd", 
  // "mode": "pw", 
  "paddingMidpoint": 33000,
  "dtt": 100000,
  "dtc": "av3",
  "itt": "ht",
  "epilogosHeaderNavbarHeight": 56,
  "hgViewconfEndpointURL": `https://${applicationEndpointRootURL}/`,
  "hgViewconfId": "aU8PPUyCQ0y5h7AjNSVicw",
  "hgViewconfEndpointURLSuffix": "api/v1/viewconfs/?d=",
  "hgViewconfAutocompleteURLSuffix": "/suggest/?d=",
  "hgViewAnimationTime": 100,
  "hgViewGeneSelectionTime": 10000,
  "hgViewTrackEpilogosHeight": 200,
  "hgViewTrackChromosomeHeight": defaultChromosomeTrackHeight,
  "hgViewTrackGeneAnnotationsHeight": 120,
  "hgGenomeURLs": {
    "hg19": `https://${applicationHost}:3000/assets/chromsizes/hg19.chrom.sizes`,
    "hg38": `https://${applicationHost}:3000/assets/chromsizes/hg38.chrom.sizes`,
    "mm10": `https://${applicationHost}:3000/assets/chromsizes/mm10.chrom.sizes`
  },
  "hgFixedBinGenomeURLs": {
    "hg19": `https://${applicationHost}:3000/assets/chromsizes/hg19.chrom.sizes.fixedBin`,
    "hg38": `https://${applicationHost}:3000/assets/chromsizes/hg38.chrom.sizes.fixedBin`,
    "mm10": `https://${applicationHost}:3000/assets/chromsizes/mm10.chrom.sizes.fixedBin`
  },
  // "hgViewTrackIndexDHSHeight": 80,
  "hgViewTrackIndexDHSHeight": 100,
};

// mode: "MsMvgs3PTtOmZK-kI-P5hw"

export const viewerHgViewParameters = {
  "genome": "hg38",
  "model": "15",
  "complexity": "KL",
  "group": "all",
  "aggregation" : "bkfq_2binWide_allSample",
  "mode": "pd", 
  // "mode": "pw", 
  "paddingMidpoint": 0,
  "dtt": 100000,
  "dtc": "av3",
  // "itt": "ht",
  // "itt": "bb",
  "itt": "hp",
  "gatt": "cv",
  "gac": "off",
  "gmax": -1,
  "epilogosHeaderNavbarHeight": 56,
  "epilogosHeaderNavbarMobileDeviceHeight": 38,
  "hgViewconfEndpointURL": `https://${applicationEndpointRootURL}/`,
  "hgViewconfId": { 
    "bkfq_2binWide_allSample": "MhAt7hTcS-ykH1MpMiRfhg"
  },
  "hgViewconfEndpointURLSuffix": "api/v1/viewconfs/?d=",
  "hgViewconfAutocompleteURLSuffix": "/suggest/?d=",
  "hgViewAnimationTime": 100,
  "hgViewGeneSelectionTime": 7000,
  "hgViewTrackEpilogosHeight": 200,
  "hgViewTrackChromatinMarksHeight": 200,
  "hgViewTrackSamplesWithDHSHeight": 40,
  "hgViewTrackIndexDHSHeight": 80,
  // "hgViewTrackIndexDHSHeight": 100,
  "hgViewTrackIndexDHSHiglassTranscriptsHeight": 100,
  "hgViewTrackDHSComponentsHeight": 250,
  "hgViewTrackChromosomeHeight": defaultChromosomeTrackHeight,
  "hgViewTrackGeneAnnotationsHeight": 100,
  "hgViewTrackGeneAnnotationsHiglassTranscriptsHeight": 480,
  "hgViewTrackGeneAnnotationsMobileDeviceHeight": 100,
  "hgViewTrackSamplesWithDHSAxisPositionHorizontal": "right",
  "hgGenomeURLs": {
    "hg19": `https://${applicationHost}:3000/assets/chromsizes/hg19.chrom.sizes`,
    "hg38": `https://${applicationHost}:3000/assets/chromsizes/hg38.chrom.sizes`,
    "mm10": `https://${applicationHost}:3000/assets/chromsizes/mm10.chrom.sizes`
  },
  "hgFixedBinGenomeURLs": {
    "hg19": `https://${applicationHost}:3000/assets/chromsizes/hg19.chrom.sizes.fixedBin`,
    "hg38": `https://${applicationHost}:3000/assets/chromsizes/hg38.chrom.sizes.fixedBin`,
    "mm10": `https://${applicationHost}:3000/assets/chromsizes/mm10.chrom.sizes.fixedBin`
  },
  "samplesToBeRendered": [],
  "numSamples": "raw",
};

export const viewerHgViewconfNumSamplesTrackType = "horizontal-point";

export const viewerHgViewconfTemplates = {
  // "pw"     : "T2BLmdbyRHyuKQvlBmh14g",
  "pc"     : "T2BLmdbyRHyuKQvlBmh14g",
  "ac"     : "T2BLmdbyRHyuKQvlBmh14g",
  "co"     : "T2BLmdbyRHyuKQvlBmh14g",
  "cf"     : "T2BLmdbyRHyuKQvlBmh14g",
  "pm"     : "T2BLmdbyRHyuKQvlBmh14g",
  "pd"     : "T2BLmdbyRHyuKQvlBmh14g",
  "pdo"    : "T2BLmdbyRHyuKQvlBmh14g",
  "pds"    : "T2BLmdbyRHyuKQvlBmh14g",
  "ft"     : "T2BLmdbyRHyuKQvlBmh14g",
};

export const viewerHgViewconfNumSamplesUUIDs = {
  "raw"    : "LKnGDwaURtm6biO9k2DP6Q",
  "log"    : "a2Qc0ubxSyy30n1ipwNU_Q",
  "sst"    : "PXeIJX3nQCi_M3W4B3yHOA",
  "rawdiv" : "PYkEqMV4T4mLmmRcFSKBfQ",
  "rawinv" : "aJ3cAu25S6a502v_3vc_Gg",
  "rawdivinv" : "ApIL7VfVRYahJNUY3ZjqBA",
};

export const viewerHgViewconfFixedBinNumSamplesUUIDs = {
  "raw"    : "UAm_qgkxSFC3rTE-9nNXaQ",
};

export const viewerHgViewconfNumSamplesValueScaleMin = {
  "raw"    : 1,
  "log"    : 0,
  "sst"    : 0,
  "rawdiv" : 0.001364256480218,
  "rawinv" : 0,
  "rawdivinv" : 0.001364256480218,
};

export const viewerHgViewconfNumSamplesValueScaleMax = {
  "raw"    : 750,
  "log"    : 2.865103974641128,
  "sst"    : 2.865103974641128,
  "rawdiv" : 1,
  "rawinv" : 732,
  "rawdivinv" : 1,
};

export const viewerHgViewconfGenomeAnnotationUUIDs = {
  "hg19" : {
    "chromsizes" : "bFIL39ioxSP6z4pDAsPb8sQ",
    "chromsizes_fixed_bin" : "S_2v_ZbeQIicTqHgGqjrTg",
    "genes" : "bJwGJttYpSueLXhUPEAv4Bw"
  },
  "hg38" : {
    "chromsizes" : "DZWWLLb8T1mYBWbKn_HdnA",
    "chromsizes_fixed_bin" : "e7yehSFuSvWu0_9uEK1Apw",
    "genes" : "Nd3aGEjkTY6SDea-qav0hA", // "Nd3aGEjkTY6SDea-qav0hA" (v28, 052730, with coloring) // "GGdqU5CMReiYGykp0-HZXQ" (v28, 052720, no coloring) // "S3KI5KVSQomVCsG1zYS6vQ" (v30, 051920, with coloring) // "JhJdxHRQRN-52p_h_ErHsA" (v30, no coloring)
    "genes_fixed_bin" : "fH_YlxYlQAmxwl_htZ4FLg", // "fH_YlxYlQAmxwl_htZ4FLg" (vD, hg38.gencode.v38.annotation.gtf.genePred.hgnc.longest.090721.fixedBin.bed14.db), "TI0NNFLlQJuYpBlKob2MbQ" (vC, promotes longest isoform), "KX5J7aIHQwi9Gw83UVRpVw" (vB, including lncRNAs etc), "f0_71v0xQRqUpgtQ8VfIGg" (v28 protein-coding, 121720, with coloring, 200bp fixed bins)
    "transcripts" : "OaYtg8d2Qw2D10wBkEYL0g", // "cv0JX4TlTIi-D1aEpV-C0A",  // gencode.v38.annotation.gtf.higlass-transcripts.hgnc.090721.forceHGNC.coloredByVocabulary.beddb (090721, 200bp-aligned)
    "CTCF_binding_sites" : "OePfQgICTy2plAj29vJ-FA",
    "CTCF_binding_sites_fixed_bin" : "ZSDzBmLvRLy-Qu3_T9TbCw",
  },
  "mm10" : {
    "chromsizes" : "X4NP8_UdQm-qAg8_P46ocg",
    "chromsizes_fixed_bin" : "ZHw2pq2tRLqsKxhOSdagWw",
    "genes" : "YZ5Wy9w2QTO5OpJmMZdsXg"
  },
};

export const viewerHgViewconfTrackIndexDHSUUID = "GE0larTnQJWVoKLZS1aMzg"; // "AkkhKTLxQyeu2-Toxio4lQ";
// export const viewerHgViewconfTrackIndexDHSUUID = "Cl5DC408Rcy0MwFL6RkLtg";
export const viewerHgViewconfTrackSuperIndexDHSUUID = {
  "original": "PKhxu0t6RcCR47ngLoBDyw",
  "011924": "GuWlzOTMQ7ed0A6yAfOYkQ",
  "042924": "TA3-EDHKSyKqPpiJNuCBoQ",
};
export const viewerHgViewconfTrackIndexDHSType = "horizontal-gene-bed12-annotations";

export const viewerHgViewconfBED12ItemRGBColormap = {
  "255,229,0"   : "Placental / trophoblast",
  "254,129,2"   : "Lymphoid",
  "255,0,0"     : "Myeloid / erythroid",
  "7,175,0"     : "Cardiac",
  "76,125,20"   : "Musculoskeletal",
  "65,70,19"    : "Vascular / endothelial",
  "5,193,217"   : "Primitive / embryonic",
  "4,103,253"   : "Neural",
  "0,149,136"   : "Digestive",
  "187,45,212"  : "Stromal A",
  "122,0,255"   : "Stromal B",
  "74,104,118"  : "Renal / cancer",
  "8,36,91"     : "Cancer / epithelial",
  "185,70,29"   : "Pulmonary development",
  "105,33,8"    : "Organ development / renal",
  "195,195,195" : "Tissue invariant"
};

export const viewerHgViewconfBED12ItemRGBSuperIndexOriginalColormap = {
  "240,248,255": "Lung cancer cell lines",
  "211,211,211": "Natural killer cells",  
  "255,235,205": "Respiratory / muscular",
  "139,69,19":   "Cerebellar hemisphere",
  "255,218,185": "B-cells (A)",
  "255,240,245": "Brain",
  "210,105,30":  "K562",
  "244,164,96":  "CD4/3 (A)",
  "8,36,91":     "T-cells (A)",
  "255,0,0":     "Gastro-endocrine system",
  "65,70,19":    "Pluripotent cells",
  "0,149,136":   "Epithelial",
  "76,125,20":   "Stromal cells",
  "185,70,29":   "CD4/3 (B)",
  "105,33,8":    "Renal",
  "7,175,0":     "Myeloid",
  "4,103,253":   "Mixed",
  "255,229,0":   "Brain",
  "74,104,118":  "T-cells (B)",
  "254,129,2":   "CD4/3 (C)",
  "122,0,255":   "MCF-7",
  "5,193,217":   "Cerebral cortex",
  "187,45,212":  "T-47D",
  "195,195,195": "CD34+ progenitor"
};

export const viewerHgViewconfBED12ItemRGBSuperIndex011824Colormap = {
  "140,198,63":    "Lung cancer cell lines",
  "187,45,212":    "Natural killer cells",  
  "221,226,35":    "Respiratory / muscular",
  "46,151,188":    "Cerebellar hemisphere",
  "230,0,155":     "B-cells (A)",
  "32,117,147":    "Brain",
  "146,23,26":     "K562",
  "184,70,27":     "CD4/3 (A)",
  "251,181,113":   "T-cells (A)",
  "0,173,149":     "Gastro-endocrine system",
  "255,229,35":    "Pluripotent cells",
  "255,218,185":   "Epithelial",
  "107,84,163":    "Stromal cells",
  "230,85,13":     "CD4/3 (B)",
  "82,110,125":    "Renal",
  "174,22,24":     "Myeloid",
  "194,194,194":   "Mixed",
  "16,89,134":     "Brain",
  "254,212,222":   "T-cells (B)",
  "253,141,60":    "CD4/3 (C)",
  "44,146,74":     "MCF-7",
  "55,193,241":    "Cerebral cortex",
  "44,103,74":     "T-47D",
  "237,32,36":     "CD34+ progenitor"
};

export const viewerHgViewconfBED12ItemRGBSuperIndex042924Colormap = {
  "231,233,233": "Tissue invariant",
  "69,49,107": "Stromal A",
  "255,222,0": "Myeloid (Monocyte)",
  "8,36,91": "Adult tissues / Muscle",
  "254,243,187": "Epithelial A",
  "255,118,0": "Myeloid (Macrophage)",
  "4,121,253": "Neural (Basal ganglia)",
  "117,156,213": "Endothelial",
  "212,142,184": "Placental A",
  "65,70,19": "Adult tissues / Cardiac",
  "74,104,118": "Digestive",
  "237,32,36": "Erythroid",
  "255,194,106": "Renal (Epithelial)",
  "194,255,237": "Respiratory (Fetal)",
  "161,239,255": "Neural (Fetal)",
  "50,166,58": "Adult tissues / Endocrine",
  "140,198,63": "Cardiac (Fetal)",
  "174,22,24": "Myeloid progenitor",
  "194,255,153": "Musculoskeletal (Fetal)",
  "255,218,185": "Epithelial B",
  "107,84,163": "Stromal B",
  "255,171,241": "Embryonic",
  "0,173,149": "Adrenal",
  "208,210,248": "Renal (Fetal)",
  "255,155,199": "Placental B",
  "55,193,241": "Neural (Cereballar)",
  "187,45,212": "Lymphoid (B-cell)",
  "59,231,150": "Thyroid",
  "230,0,155": "Lymphoid (T-cell/NK-cell)"
};

export const viewerHgViewconfColormaps = {
  'hg19' : {
    '15' : [
      '#ff0000',
      '#ff4500',
      '#32cd32',
      '#008000',
      '#006400',
      '#c2e105',
      '#ffff00',
      '#66cdaa',
      '#8a91d0',
      '#cd5c5c',
      '#e9967a',
      '#bdb76b',
      '#808080',
      '#c0c0c0',
      '#ffffff'
    ],
    '18' : [
      '#ff0000',
      '#ff4500',
      '#ff4500',
      '#ff4500',
      '#008000',
      '#006400',
      '#c2e105',
      '#c2e105',
      '#ffc34d',
      '#ffc34d',
      '#ffff00',
      '#66cdaa',
      '#8a91d0',
      '#cd5c5c',
      '#bdb76b',
      '#808080',
      '#c0c0c0',
      '#ffffff',
    ],
    '25' : [
      '#ff0000',
      '#ff4500',
      '#ff4500',
      '#ff4500',
      '#008000',
      '#008000',
      '#008000',
      '#009600',
      '#c2e105',
      '#c2e105',
      '#c2e105',
      '#c2e105',
      '#ffc34d',
      '#ffc34d',
      '#ffc34d',
      '#ffff00',
      '#ffff00',
      '#ffff00',
      '#ffff66',
      '#66cdaa',
      '#8a91d0',
      '#e6b8b7',
      '#7030a0',
      '#808080',
      '#ffffff',
    ]
  },
  'hg38' : {
    '15' : [
      '#ff0000',
      '#ff4500',
      '#32cd32',
      '#008000',
      '#006400',
      '#c2e105',
      '#ffff00',
      '#66cdaa',
      '#8a91d0',
      '#cd5c5c',
      '#e9967a',
      '#bdb76b',
      '#808080',
      '#c0c0c0',
      '#ffffff'
    ],
    '18' : [
      '#ff0000',
      '#ff4500',
      '#ff4500',
      '#ff4500',
      '#008000',
      '#006400',
      '#c2e105',
      '#c2e105',
      '#ffc34d',
      '#ffc34d',
      '#ffff00',
      '#66cdaa',
      '#8a91d0',
      '#cd5c5c',
      '#bdb76b',
      '#808080',
      '#c0c0c0',
      '#ffffff',
    ],
    '25' : [
      '#ff0000',
      '#ff4500',
      '#ff4500',
      '#ff4500',
      '#008000',
      '#008000',
      '#008000',
      '#009600',
      '#c2e105',
      '#c2e105',
      '#c2e105',
      '#c2e105',
      '#ffc34d',
      '#ffc34d',
      '#ffc34d',
      '#ffff00',
      '#ffff00',
      '#ffff00',
      '#ffff66',
      '#66cdaa',
      '#8a91d0',
      '#e6b8b7',
      '#7030a0',
      '#808080',
      '#ffffff',
    ]
  },
  'mm10' : {
    '15' : [
      '#0e6f37',
      '#c7e4c0',
      '#cdcdcd',
      '#41ac5e',
      '#f3eb1a',
      '#f3eb1a',
      '#faf8c8',
      '#808080',
      '#808080',
      '#0454a3',
      '#deecf7',
      '#4290cf',
      '#f48c8f',
      '#fde2e5',
      '#ffffff',
    ]
  }
}

export const viewerHgViewconfDTCCategoryUUIDs = {
  "1k" : { "uuid" : "CzI6co3zT9OLkkHrcVb4Iw", "type" : "bedlike" },
  "2k" : { "uuid" : "MjL6xAxPRjy2emaPxhM7SA", "type" : "bedlike" },
  "3k" : { "uuid" : "ZhIjEiuCSWiHM_C3f1OrBw", "type" : "bedlike" },
  "4k" : { "uuid" : "cgel0OqGT4qcj284BSxjmg", "type" : "bedlike" },
  "5k" : { "uuid" : "ZZwtUti5Sh-2nYk21N-5YQ", "type" : "bedlike" },
  "6k" : { "uuid" : "cvRT-wFpSXqJPvk1cFryYg", "type" : "bedlike" },
  "7k" : { "uuid" : "JpsngKrWT3iGofZrVnUT2w", "type" : "bedlike" },
  "8k" : { "uuid" : "IiEE-xlxQuqUalepfW0bng", "type" : "bedlike" },
  "9k" : { "uuid" : "fBxLj5mbQ1e1YfXalG3Ypw", "type" : "bedlike" },
  "10k" : { "uuid" : "ZF-FhRNwR9SfME4TviJ-1A", "type" : "bedlike" },
  "11k" : { "uuid" : "U46tCyQRQ_-ZB92f4vUMJw", "type" : "bedlike" },
  "12k" : { "uuid" : "ZvsSUW6jT26wB6Cwk-DhAg", "type" : "bedlike" },
  "13k" : { "uuid" : "VCwRmGg4QJW2phUxcjMNlQ", "type" : "bedlike" },
  "14k" : { "uuid" : "fEyTIWMZT5e5d8LCYPBB5g", "type" : "bedlike" },
  "15k" : { "uuid" : "RNTqeNxCQH-VyARn0LNldA", "type" : "bedlike" },
  "16k" : { "uuid" : "UQ3SQyw_Qdao_ZkHy1crLw", "type" : "bedlike" },
  "17k" : { "uuid" : "Ciz-7iQnRmW_w7VAQlLzFg", "type" : "bedlike" },
  "18k" : { "uuid" : "H-wp-l8oQsOs52MOw6m45w", "type" : "bedlike" },
  "19k" : { "uuid" : "L8RGKNnyQ3eVEsfWBirq-Q", "type" : "bedlike" },
  "20k" : { "uuid" : "N85ZYRtgRta2cxY_molC9g", "type" : "bedlike" },
  "21k" : { "uuid" : "F5THeBMBQ-iLiCuv-VPo0w", "type" : "bedlike" },
  "22k" : { "uuid" : "a4zLT8ATTA-z8EtHROZVuQ", "type" : "bedlike" },
  "23k" : { "uuid" : "Nt0QoIunReemkKwzNrAbTw", "type" : "bedlike" },
  "24k" : { "uuid" : "cFysgYrQTRuOjvE8BM5iVw", "type" : "bedlike" },
  "25k" : { "uuid" : "ReuBaKsbRemI2DoAz4NWuA", "type" : "bedlike" },
  "all" : { "uuid" : "QHNolzUoTSu-rjGv3RtbNA", "type" : "horizontal-multivec" },
  "av3" : { "uuid" : "ZI2wkmWVSTa7LU5lxVDKgw", "type" : "horizontal-multivec" },
  "av4" : { "uuid" : "EEmPP1aEQI6nsHSUoCHZng", "type" : "horizontal-multivec" }, // multiDHS_domains.threshold_1.111020.matrix.version_sorted.multires.mv5
  "av5" : { "uuid" : "UX9nWietShysh3zXaIbxxw", "type" : "horizontal-multivec" }, // multiDHS_domains.threshold_0_and_1_partition_union.111020.matrix.version_sorted.multires.mv5 
}

//
// Query parameters
//

export const allowedQueryParameters = {
  "application"           : "application",
  "genome"                : "genome assembly",
  "chrLeft"               : "chromosome (left)",
  "chrRight"              : "chromosome (right)",
  "start"                 : "start position",
  "stop"                  : "stop position",
  "mode"                  : "viewer mode",
  "stfIdx"                : "selected TF row index",
  "spcIdx"                : "selected protein-coding row index",
  "numSamples"            : "how many samples a DHS occurs in",
  "dtt"                   : "nt threshold before switching the Index DHS track to a DHS Component track",
  "dtc"                   : "DHS component width category",
  "roiSet"                : "regions-of-interest set name",
  "roiURL"                : "regions-of-interest URL",
  "srrIdx"                : "selected ROI row index (1-based)",
  "roiMode"               : "regions-of-interest display mode",
  "roiPaddingFractional"  : "regions-of-interest padding (fraction)",
  "roiPaddingAbsolute"    : "regions-of-interest padding (absolute)",
  "activeTab"             : "active drawer tab upon open",
  "itt"                   : "Index DHS track type",
  "gatt"                  : "Gene annotation track type",
  "gac"                   : "Gene annotation block count flag (on|off)",
  "gmax"                  : "Signal global max",
}
export const allowedQueryParameterKeys = Object.keys(allowedQueryParameters);

// ?gmax=xyz
export const defaultApplicationSignalGlobalMax = -1;

// ?application=xyz
export const applications = {
  "blank" :       "default",
  "portal" :      "application portal",
  "viewer" :      "data viewer"
};
export const applicationKeys = Object.keys(applications);
export const defaultApplication = "blank";
export const applicationBlank = "blank";
export const applicationPortal = "portal";
export const applicationViewer = "viewer";

// drawer width
export const defaultMinimumDrawerWidth = 337;
export const defaultMaximumDrawerWidth = 445;

// ?mode=xyz
export const applicationModes = modes;
export const defaultApplicationMode = "pd";

// ?numSamples=xyz
export const applicationNumSamples = numSamples;
export const defaultApplicationNumSamples = "raw";

// ?genome=xyz
export const applicationGenomes = genomes;
export const applicationGenomeKeys = Object.keys(applicationGenomes);
export const defaultApplicationGenome = "hg38";
export const applicationGenomeHg19 = "hg19";
export const applicationGenomeHg38 = "hg38";
export const applicationGenomeMm10 = "mm10";

// ?model=xyz
export const applicationModels = {
  "15" : "15-state model",
  "18" : "18-state model",
  "25" : "25-state model",
};
export const applicationModelKeys = Object.keys(applicationModels);
export const defaultApplicationModel = "15";
export const applicationModel15 = "15";
export const applicationModel18 = "18";
export const applicationModel25 = "25";

// ?complexity=xyz
export const applicationComplexities = {
  "KL" : "Kullback–Leibler divergence (level 1)",
  "KLs" : "Kullback–Leibler divergence (level 2)",
  "KLss" : "Kullback–Leibler divergence (level 3)",
};
export const applicationComplexityKeys = Object.keys(applicationComplexities);
export const defaultApplicationComplexity = "KL";
export const applicationComplexityKL = "KL";
export const applicationComplexityKLs = "KLs";
export const applicationComplexityKLss = "KLss";

// ?group=xyz
export const applicationGroups = groupsByGenome;
export const applicationGroupKeys = Object.keys(applicationGroups[defaultApplicationGenome]);
export const defaultApplicationGroup = "all";

// ?chr=xyz
export const defaultApplicationChr = "chr19";

// ?start=xyz
export const defaultApplicationStart = 54635800;

// ?stop=xyz
export const defaultApplicationStop = 54674200;

export const defaultApplicationPositions = {
  'hg19' : {
    'chr' : 'chr19',
    'start' : 54635800,
    'stop' : 54674200,
  },
  'hg38' : {
    'chr' : 'chr7',
    'start' : 27132932,
    'stop' : 27135531,
  },
  'mm10' : {
    'chr' : 'chr6',
    'start' : 52155367,
    'stop' : 52158317,
  },
}

export const defaultApplicationRoiLineLimit = 100;

export const defaultApplicationSerIdx = -1;
export const defaultApplicationSrrIdx = -1;

export const applicationRoiModes = {
  'default' : 'default',
  'midpoint' : 'midpoint',
};

export const applicationIttModes = {
  'bb' : 'bb', // bigBed track
  'ht' : 'ht', // higlass-transcripts (boxplot) track
  'hp' : 'hp', // higlass-pileup (boxplot) track
};

export const applicationGattModes = {
  'cv' : 'cv', // conventional track
  'ht' : 'ht', // higlass-transcripts (directional or UCSC-like) track
};

export const applicationGacModes = {
  'on' : true, // counting enabled
  'off' : false, // disabled
};

export const assembliesForGenomeCategory = {
  "Human" : ["hg38"],
};

export const defaultApplicationRoiMode = "default";
export const defaultApplicationRoiPaddingAbsolute = 1000;
export const defaultApplicationRoiSetPaddingAbsolute = 10000;
export const defaultApplicationRoiPaddingFraction = 0.2;
export const defaultApplicationDttThreshold = 200000;
export const defaultApplicationDtcCategory = "av3";
export const defaultApplicationIttCategory = "hp";
// export const defaultApplicationIttCategory = "ht";
// export const defaultApplicationIttCategory = "bb";
export const defaultApplicationGattCategory = "cv";
export const defaultApplicationGacCategory = "off";

export const dhsComponentMd = {
  "1":  {"name": "Tissue-invariant", "color": "#c3c3c3"},
  "2":  {"name": "Stromal A", "color": "#bb2dd4"}, 
  "3":  {"name": "Embryonic", "color": "#05c1d9"}, 
  "4":  {"name": "Stromal B", "color": "#7a00ff"}, 
  "5":  {"name": "Lymphoid", "color": "#fe8102"}, 
  "6":  {"name": "Renal / cancer", "color": "#4a6876"}, 
  "7":  {"name": "Placental / trophoblast", "color": "#ffe500"},
  "8":  {"name": "Neural", "color": "#0467fd"},
  "9":  {"name": "Cardiac", "color": "#07af00"},
  "10": {"name": "Organ development / renal", "color": "#692108"}, 
  "11": {"name": "Pulmonary development", "color": "#b9461d"}, 
  "12": {"name": "Musculoskeletal", "color": "#4c7d14"}, 
  "13": {"name": "Digestive", "color": "#009588"}, 
  "14": {"name": "Vascular / endothelial", "color": "#414613"},
  "15": {"name": "Myeloid / erythroid", "color": "#ff0000"}, 
  "16": {"name": "Cancer / epithelial", "color": "#08245b"}, 
  "17": {"name": "NaN", "color": "#ffffff"}
}

export const dhsComponentLabels = [
  "Tissue-invariant",
  "Stromal A",
  "Embryonic",
  "Stromal B",
  "Lymphoid",
  "Renal / cancer",
  "Placental / trophoblast",
  "Neural",
  "Cardiac",
  "Organ development / renal",
  "Pulmonary development",
  "Musculoskeletal",
  "Digestive",
  "Vascular / endothelial",
  "Myeloid / erythroid",
  "Cancer / epithelial",
];

export const dhsComponentTwoLevelLabels = [
  "Tissue-invariant",
  "Stromal A",
  "Embryonic",
  "Stromal B",
  "Lymphoid",
  "Renal / cancer",
  "Placental / trophoblast",
  "Neural",
  "Cardiac",
  "Organ development / renal",
  "Pulmonary development",
  "Musculoskeletal",
  "Digestive",
  "Vascular / endothelial",
  "Myeloid / erythroid",
  "Cancer / epithelial",
  "Tissue-invariant",
  "Stromal A",
  "Embryonic",
  "Stromal B",
  "Lymphoid",
  "Renal / cancer",
  "Placental / trophoblast",
  "Neural",
  "Cardiac",
  "Organ development / renal",
  "Pulmonary development",
  "Musculoskeletal",
  "Digestive",
  "Vascular / endothelial",
  "Myeloid / erythroid",
  "Cancer / epithelial",
];

export const dhsComponentColorsAsRgb = [
  "rgba(195,195,195,1)",  // tissue-invariant
  "rgba(187,45,212,1)",   // stromal A
  "rgba(5,193,217,1)",    // embryonic
  "rgba(122,0,255,1)",    // stromal B
  "rgba(254,129,2,1)",    // lymphoid
  "rgba(74,104,118,1)",   // renal / cancer
  "rgba(255,229,0,1)",    // placental / trophoblast
  "rgba(4,103,253,1)",    // neural
  "rgba(7,175,0,1)",      // cardiac
  "rgba(105,33,8,1)",     // organ dev. / renal
  "rgba(185,70,29,1)",    // pulmonary dev.
  "rgba(76,125,20,1)",    // musculoskeletal
  "rgba(0,149,136,1)",    // digestive
  "rgba(65,70,19,1)",     // vascular / endothelial
  "rgba(255,0,0,1)",      // myeloid / erythroid
  "rgba(8,36,91,1)",      // cancer / epithelial
  "rgba(255,255,255,1)",  // NaN
];

export const dhsComponentColorsAsHex = [
  "#c3c3c3",
  "#bb2dd4", 
  "#05c1d9", 
  "#7a00ff", 
  "#fe8102", 
  "#4a6876", 
  "#ffe500",
  "#0467fd",
  "#07af00",
  "#692108", 
  "#b9461d", 
  "#4c7d14", 
  "#009588", 
  "#414613",
  "#ff0000", 
  "#08245b",
];

export const dhsComponentTwoLevelColorsAsRgb = [
  "rgba(195,195,195,1)",  // tissue-invariant
  "rgba(187,45,212,1)",   // stromal A
  "rgba(5,193,217,1)",    // embryonic
  "rgba(122,0,255,1)",    // stromal B
  "rgba(254,129,2,1)",    // lymphoid
  "rgba(74,104,118,1)",   // renal / cancer
  "rgba(255,229,0,1)",    // placental / trophoblast
  "rgba(4,103,253,1)",    // neural
  "rgba(7,175,0,1)",      // cardiac
  "rgba(105,33,8,1)",     // organ dev. / renal
  "rgba(185,70,29,1)",    // pulmonary dev.
  "rgba(76,125,20,1)",    // musculoskeletal
  "rgba(0,149,136,1)",    // digestive
  "rgba(65,70,19,1)",     // vascular / endothelial
  "rgba(255,0,0,1)",      // myeloid / erythroid
  "rgba(8,36,91,1)",      // cancer / epithelial
  "rgba(225,225,225,1)",  // tissue-invariant
  "rgba(231,183,240,1)",  // stromal A
  "rgba(207,236,240,1)",  // embryonic
  "rgba(217,194,243,1)",  // stromal B
  "rgba(254,212,168,1)",  // lymphoid
  "rgba(188,205,213,1)",  // renal / cancer
  "rgba(249,243,190,1)",  // placental / trophoblast
  "rgba(190,216,255,1)",  // neural
  "rgba(206,243,205,1)",  // cardiac
  "rgba(249,191,171,1)",  // organ dev. / renal
  "rgba(241,187,167,1)",  // pulmonary dev.
  "rgba(195,237,148,1)",  // musculoskeletal
  "rgba(168,221,217,1)",  // digestive
  "rgba(216,224,142,1)",  // vascular / endothelial
  "rgba(255,168,168,1)",  // myeloid / erythroid
  "rgba(126,166,243,1)",  // cancer / epithelial
  "rgba(255,255,255,1)",  // NaN
];

export const defaultRoiTableDataLongestNameLength = 4;
export const defaultRoiTableDataLongestAllowedNameLength = 20;

export const roiSets = {
  "TFassoc_Meuleman" : `chr5	148406500	148406760	GATA6,GATA4-GATA	1.53028509090909	.
chr20	1197900	1198100	HOXB3,HOXB5-HD_2	2.89165620833333	.
chr5	173278741	173278970	TBX20,VEZF1,NKX2-5,SP2,RARA,NR4A1-SMAD	3.7544327	.
chr8	32241300	32241440	ZNF274-ZNF274	2.7968	.
chr7	107494240	107494520	HEY2,ESR2,NPAS2-Ebox_CACGTG_1	2.65146838888889	.
chr5	171728760	171729000	GATA1-GATA	4.98635211111111	.
chr16	51242380	51242580	HOXD3,HOXA2,NKX3-2,EMX2,HOXA1,HOXB4,VENTX,DLX1,EVX2-HD_2	1.4469338	.
chr6	167806360	167806580	HNF4G,KLF5,HNF4A,PPARA,NR5A2,NFAT5-NR_1	4.62458332142857	.
chr17	71843000	71843320	FOSL2,HOXB7,FOSL1,TBX15-AP1_1	4.25767236363636	.
chr1	64037480	64037719	PROX1-PROX1	1.31237511111111	.
chr15	60033580	60033760	FOXP3,IRF4,IRF1,IRF8,IRF2-FOX_5	6.22996	.
chr16	12338340	12338620	ELK3,ERG,NFATC1,FLI1,NFIA-ETS_1	6.23510177777778	.
chr19	882740	883060	GCM1,TEAD3-GCM	4.86396314285714	.
chr16	66984740	66985200	USF1,ETS1,XBP1,ELF1,ERF,ZNF394,BCL6,ETV1,NFATC3-Ebox_CACGTG_1	6.5867465	.
chr17	47860480	47860680	NR2F1,HOXC10,HOXD9,HOXD11,HOXA13,ETV4,FEV,HOXC13,HOXC12,PATZ1,WT1,HOXC9-NR_1	2.58664222222222	.
chr15	75738860	75738940	IKZF1,RELB,RELA,RORC,NFKB2,NFKB1-ZNF143	9.86304	.
chr10	62655480	62655720	MEF2B-MEF2	6.099452	.
chr16	6709596	6709960	TFAP2B,NEUROD1,ASCL1,PTF1A,ATOH1-TFAP2_1	5.183333	.
chr5	546680	546904	EHF,ELF3-ETS_1	2.88070842105263	.
chr9	27412180	27412455	DPRX-HD_20	2.23640346153846	.
chr15	69510580	69510960	NFE2,MYB,KLF1,POU5F1B,RREB1,STAT3,ETV6-AP1_1	4.57083325	.
chr2	130355800	130355885	ZNF134-ZNF134	0.7794	.
chr8	108202580	108202780	PRDM6-NFAC_2	2.2324555	.
chr13	95502320	95502520	HSF2-HSF	3.26279883333333	.
chr2	50680759	50680927	AIRE-AIRE	0.538681266666667	.
chr1	223610020	223610275	HOXB8,POU3F3-HD_16	1.53720671428571	.
chr2	112972440	112972740	MEOX2,POU6F2,TCFL5,NOBOX,LMX1B,LMX1A-HD_2	4.3674722	.
chr18	63886048	63886298	SPDEF,TP63,SREBF2-SPDEF_2	4.38977866666667	.
chr12	131425520	131425740	ATF2-CREB_ATF_1	6.14648	.
chr10	91611000	91611220	ZNF76,NFIB,TBX5-ZNF143	3.60585428571429	.
chr11	94008000	94008300	SPI1-SPI	4.93449	.
chr4	6180920	6181213	SPIB,STAT4-SPI	7.32843091891892	.
chr3	73498820	73499040	NRL,MAFF,NFIC,MAFK-MAF	3.41477585714286	.
chr7	151722660	151722860	MEIS2,MEIS1-MIES	2.82042442105263	.
chr1	212248140	212248360	HNF1B,HNF1A-HD_10	2.77805092857143	.
chr21	33296220	33296460	ZNF331-ZNF331	4.07469125	.
chr22	31987289	31987540	CDX2,ARID3A-HD_18	3.39674241176471	.
chr9	6757980	6758220	CEBPD,TEF-CCAAT_CEBP	2.49634	.
chr10	127578940	127579260	STAT1,PPARG-STAT_2	3.9658305	.
chr6	28117480	28117680	TWIST2,CLOCK,AR,TFE3,CREB3L1,RBPJ-Ebox_CATATG	1.27591682352941	.
chr12	121989320	121989660	PAX2,PAX9-PAX_1	1.59527481818182	.
chr20	60648600	60648900	GFI1B-GFI	3.24843266666667	.
chr6	150427900	150428160	NR2F2,TBX1,TBX2,TBR1-NR_12	1.6791934	.
chr19	51108640	51108740	ZBTB14-ZBTB14	2.49634	.
chr8	97631300	97631580	PROP1-HD_8	4.44754016666667	.
chr11	57438960	57439220	IRF3,IRF9,FOXJ3,SOX10,ZFP57-IRF_1,IRF_2	3.75510985714286	.
chr2	15958216	15958621	NR2E1-NR_14	2.93943504347826	.
chr12	25698854	25699100	PRRX1,RUNX2,PRRX2-HD_2	0.83970816	.
chr3	187802980	187803180	POU2F2-POU_1	5.91910585185185	.
chr4	88297761	88298040	MEF2A,CREM,MEF2C-MEF2	2.07831704761905	.
chr15	26165620	26166020	NKX6-2,VSX2,EN2,ISL1,DLX6,LHX9,NKX6-1,SOX1,DLX5,GSX1,SOX8,SHOX2,ARX,GSX2,SOX17,SP8,ALX1,ZIC1-HD_2	5.281355	.
chr5	35811500	35811680	RUNX3,ZBTB7B,KLF13,E2F1,EGR2,RORA,KLF16,KLF12-RUNX_1	11.398	.
chr16	89014440	89014660	POU4F2,POU4F1,POU4F3-POU_2	1.79616	.
chr8	69977400	69977660	HMX1,HMX3,ISL2-HD_4	3.4437327	.
chr14	67958013	67958220	FOXF2,FOXP2-FOX_5	3.41434444827586	.
chr22	35128700	35128920	PRDM1,E2F2-PRDM1	4.59710111111111	.
chr3	154866100	154866267	HIF1A-HIF	0.311216125	.
chr5	120442780	120443020	RARB-NR_16	3.20286118181818	.
chr1	212852180	212852416	ONECUT3,PAX7,ONECUT1-CUX_1	2.36984813333333	.
chr11	10338392	10338575	NFATC2,SHOX,LHX8,MEOX1,NR1D1,TCF3,TFDP1-NFAT_1	1.9738543	.
chr17	12390727	12390936	KLF15,CREB5-GC-tract	1.75174428	.
chr18	79532180	79532360	ZIC3,PBX3,ZIC4,INSM1,ZIC2,E2F7-ZIC	4.55706	.
chr11	124659103	124659280	POU3F4-POU_1	2.761185875	.
chr1	111598571	111598860	LIN54-LIN54	2.82070865217391	.
chr19	5220060	5220340	ATF3,JDP2-AP1_1	2.9995705	.
chr3	7346420	7346680	SOX18-SOX_3,SOX_5	4.92136866666667	.
chr13	90396320	90396780	HOXD13,HIC2,GBX1,MNX1,VAX2,EMX1,EN1,VAX1,HOXD12,SP7,VSX1,HSF4,LHX4,ZNF816,DLX3,LHX6,LBX2,ALX3,BSX,GBX2,RAX,RAX2,ARID3B,LHX2,PAX4,EVX1,DLX4-HD_17,HD_18	3.92816716666667	.
chr6	30067260	30067340	MYC,ELF2,ZNF770,MYCN,ZNF263,EGR1,ZEB1-Ebox_CACGTG_2	3.61969	.
chr7	132565480	132565800	FOXG1,FOXB1-FOX_5	4.1221	.
chr6	43880800	43881040	PKNOX2,MEIS3-MIES	1.744375	.
chr17	42998115	42998200	ZNF382-ZNF382	2.71347	.
chr19	29770060	29770280	USF2,CREB3L2,MZF1,HES2,ZNF320-Ebox_CACGTG_1	3.5678005	.
chr3	184665100	184665440	ZSCAN4-ZSCAN4	2.95209414285714	.
chr2	234985820	234986240	NR1I2-NR_16	3.47904	.
chr15	78149020	78149140	NFYA-NFY	2.02094	.
chrX	63364240	63364460	ZBTB49,BARX1,PDX1,MSX2,FOXA3,MSX1,FOXA2-ZBTB49	4.231245	.
chr5	134539760	134540100	TBX21,T,TBX4,GCM2,TBX3,TFAP2A,TFAP2C,SOX15-TBX_3,TBX_4	4.70644664285714	.
chr16	1065620	1065820	FOXO6-FOX_7	1.61854828571429	.
chr3	142934548	142934780	BACH1-AP1_2	3.23682307692308	.
chr11	2406549	2406774	MSC,ZBTB7C,ESRRB-Ebox_CAGCTG	2.51693130434783	.
chr13	93216191	93216500	DRGX,PHOX2B,HAND1-HD_8	3.48993312	.
chr7	6363760	6363980	NR1H4-NR_18	3.49820395	.
chr4	152079960	152080180	LEF1,TCF7,GFI1-TCF_LEF,LEF1	6.07583037837838	.
chr18	36350248	36350500	UNCX,PHOX2A-HD_8	1.74025104	.
chr11	114784960	114785240	HES5-Ebox_CACGTG_1	3.00082733333333	.
chr15	52745420	52745700	NEUROG1,BHLHA15,OLIG3-Ebox_CATATG	2.60808818181818	.
chr19	46204022	46204314	ZNF528-ZNF528	2.86837836363636	.
chr7	101294080	101294360	NKX2-2,NKX2-3,NANOG,OLIG2,FOXI1,MYOG,NKX2-1,MYOD1,ASCL2,ELF5,NHLH1,TEAD4,POU5F1,ZNF740-HD_22	4.82161984615385	.
chr14	77116280	77116540	RORB-NR_19	4.20164583333333	.
chr6	118871440	118871640	MECOM-EVI1_MECOM	1.10069391666667	.
chr11	32417880	32418125	FEZF1-FEZF1	1.29805571428571	.
chr7	6183880	6184060	GMEB2,GATA3-GMEB2_2	2.50818833333333	.
chr2	231680960	231681025	GLIS1,GLIS2-GLIS	2.32288	.
chr3	40502080	40502359	E2F3-E2F_2	4.33673466666667	.
chr5	59731913	59732080	MAF-MAF	2.49347461538462	.
chr1	103267360	103267548	IRX2-HD_23	0.674712136363636	.
chr2	161969248	161969500	PAX1,PAX6-PAX_1	2.0535035	.
chr7	132785992	132786146	FOXL1-FOX_5	1.294144	.
chr5	154026040	154026260	LYL1-Ebox_CAGATGG	4.541023	.
chr5	31100240	31100560	MAFG,MITF-MAF	2.69251669230769	.`
};

export const hgViewconfTemplate = {
  "editable" : false,
  "zoomFixed" : false,
  "trackSourceServers" : [
    "/api/v1",
    "http://higlass.io/api/v1"
  ],
  "exportViewUrl" : "/api/v1/viewconfs/",
  "views" : [
    {
      "tracks" : {
        "top" : [
          {
            "name" : "",
            "created" : "",
            "project" : "",
            "project_name" : "",
            "description" : "",
            "server" : `https://${applicationEndpointRootURL}/api/v1`,
            "tilesetUid" : "",
            "uid" : "",
            "type" : "",
            "position" : "top",
            "options" : {},
            "resolutions" : [],
          }
        ],
        "left" : [],
        "center" : [],
        "right" : [],
        "bottom" : [],
        "whole" : [],
        "gallery" : []
      },
      "initialXDomain" : [],
      "initialYDomain" : [],
      "layout" : {
        "w" : 12,
        "h" : 12,
        "x" : 0,
        "y" : 0,
        "i" : "CLH4ybW8ToynSKBby7aB4g",
        "moved" : false,
        "static" : false
      },
      "uid" : "CLH4ybW8ToynSKBby7aB4g",
      "options" : {
        "backgroundColor" : "black"
      }
    }
  ],
  "zoomLocks" : {
    "locksByViewUid" : {},
    "locksDict" : {}
  },
  "locationLocks" : {
    "locksByViewUid" : {},
    "locksDict" : {}
  },
  "valueScaleLocks" : {
    "locksByViewUid" : {},
    "locksDict" : {}
  }
};

export const hgViewconfPortalTemplate = {
  "editable": false,
  "zoomFixed": false,
  "trackSourceServers": [
    "/api/v1",
    "http://higlass.io/api/v1"
  ],
  "exportViewUrl": "/api/v1/viewconfs/",
  "views": [
    {
      "tracks": {
        "top": [
          {
            "name": "16ComponentStackedDelta",
            "created": "2019-04-11T15:14:45.621908Z",
            "project": "b",
            "project_name": "",
            "description": "",
            "server": `https://${applicationEndpointRootURL}/api/v1`,
            "tilesetUid": "HlXADoAsQt6tTm-NkrhWgw",
            "uid": "6cdc45a6-2ea8-4144-abfb-b11702344d38",
            "type": "horizontal-stacked-delta-bar",
            "options": {
              "labelPosition": "topLeft",
              "labelColor": "black",
              "labelTextOpacity": 0,
              "valueScaling": "linear",
              "trackBorderWidth": 0,
              "trackBorderColor": "black",
              "minHeight": 0,
              "backgroundColor": "black",
              "colorRange": [
                "rgba(255,255,255,1)",
                "rgba(0,0,0,1)"
              ],
              "colorScale": [
                "#ffe600",
                "#ff8203",
                "#ff0000",
                "#05b000",
                "#4c7d14",
                "#404513",
                "#04c0d9",
                "#0568fc",
                "#009488",
                "#bb2cd4",
                "#7a00ff",
                "#4a6775",
                "#08265c",
                "#ba471e",
                "#691f08",
                "#c2c2c2"
              ],
              "labelBackgroundOpacity": 0,
              "valueScaleMin": 0,
              "valueScaleMax": 4,
              "name": "All samples",
              "showMousePosition": true,
              "colorbarPosition": null,
              "barBorder": false,
              "sortLargestOnTop": true,
              "fillOpacityMin": 0.2,
              "fillOpacityMax": 0.8
            },
            "width": 1371,
            "height": 143,
            "position": "top",
            "resolutions": [
              13107200,
              6553600,
              3276800,
              1638400,
              819200,
              409600,
              204800,
              102400,
              51200,
              25600,
              12800,
              6400,
              3200,
              1600,
              800,
              400,
              200
            ]
          },
          {
            "name": "ChromosomeAxis",
            "created": "2019-04-11T15:11:47.798450Z",
            "project": "bLwQYp24jRG2YyAxGaGGwMg",
            "project_name": "",
            "description": "",
            "server": `https://${applicationEndpointRootURL}/api/v1`,
            "tilesetUid": "e7yehSFuSvWu0_9uEK1Apw",
            "uid": "59f2e64e-ec27-4f18-affa-492ffa9c8cfb",
            "type": "horizontal-chromosome-labels",
            "options": {
              "color": "#777777",
              "stroke": "#FFFFFF",
              "fontSize": 12,
              "fontIsAligned": false,
              "showMousePosition": true,
              "mousePositionColor": "#999999",
              "backgroundColor": "white"
            },
            "width": 1371,
            "height": 25,
            "position": "top"
          },
          {
            "name": "hg38.gencode.v30.annotation.gtf.genePred.hgnc.longest.bed14.db",
            "created": "2019-04-11T15:12:04.391612Z",
            "project": "bLwQYp24jRG2YyAxGaGGwMg",
            "project_name": "",
            "description": "",
            "server": `https://${applicationEndpointRootURL}/api/v1`,
            "tilesetUid": "D5k7ajwfT9mzwbybaSS0VA",
            "uid": "0b36ef90-b511-4bbd-9ddc-6744d415ba4a",
            "type": "horizontal-transcripts",
            "options": {
              "fontSize": 11,
              "labelColor": "black",
              "labelPosition": "hidden",
              "labelLeftMargin": 0,
              "labelRightMargin": 0,
              "labelTopMargin": 0,
              "labelBottomMargin": 0,
              "plusStrandColor": "blue",
              "minusStrandColor": "red",
              "trackBorderWidth": 0,
              "trackBorderColor": "black",
              "showMousePosition": true,
              "mousePositionColor": "#999999",
              "geneAnnotationHeight": 10,
              "geneLabelPosition": "outside",
              "geneStrandSpacing": 4,
              "name": "hg38.gencode.v30.annotation.gtf.genePred.hgnc.longest.bed14.db",
              "blockStyle": "boxplot",
              "showToggleTranscriptsButton": false,
              "labelFontSize": "11",
              "labelFontWeight": "500",
              "maxTexts": 100,
              "maxRows": 2,
              "minHeight": 66,
              "itemRGBMap": {
                "255,229,0": "Placental / trophoblast",
                "254,129,2": "Lymphoid",
                "255,0,0": "Myeloid / erythroid",
                "7,175,0": "Cardiac",
                "76,125,20": "Musculoskeletal",
                "65,70,19": "Vascular / endothelial",
                "5,193,217": "Primitive / embryonic",
                "4,103,253": "Neural",
                "0,149,136": "Digestive",
                "187,45,212": "Stromal A",
                "122,0,255": "Stromal B",
                "74,104,118": "Renal / cancer",
                "8,36,91": "Cancer / epithelial",
                "185,70,29": "Pulmonary development",
                "105,33,8": "Organ development / renal",
                "195,195,195": "Tissue invariant"
              },
              "startCollapsed": false,
              "trackMargin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
              },
              "transcriptHeight": 20,
              "transcriptSpacing": 5,
              "isVisible": true
            },
            "width": 1371,
            "height": 66,
            "header": "1\t2\t3\t4\t5\t6\t7\t8\t9\t10\t11\t12\t13\t14",
            "position": "top"
          },
          {
            "name": "hg38.gencode.v30.annotation.gtf.genePred.hgnc.longest.bed14.db",
            "created": "2019-04-11T15:12:04.391612Z",
            "project": "bLwQYp24jRG2YyAxGaGGwMg",
            "project_name": "",
            "description": "",
            "server": `https://${applicationEndpointRootURL}/api/v1`,
            "tilesetUid": "KPNgc7HhS4ilhcv0Cr95vg",
            "uid": "473ad6a3-d0dd-4c23-9378-d8f4ee3fdf7d",
            "type": "horizontal-transcripts",
            "options": {
              "fontSize": 11,
              "labelColor": "black",
              "labelPosition": "hidden",
              "labelLeftMargin": 0,
              "labelRightMargin": 0,
              "labelTopMargin": 0,
              "labelBottomMargin": 0,
              "plusStrandColor": "#666666",
              "minusStrandColor": "#666666",
              "trackBorderWidth": 0,
              "trackBorderColor": "black",
              "showMousePosition": true,
              "mousePositionColor": "#999999",
              "geneAnnotationHeight": 10,
              "geneLabelPosition": "outside",
              "geneStrandSpacing": 4,
              "name": "hg38.gencode.v30.annotation.gtf.genePred.hgnc.longest.bed14.db",
              "maxRows": 3,
              "minHeight": 60,
              "startCollapsed": false,
              "blockStyle": "directional",
              "showToggleTranscriptsButton": false,
              "utrColor": "#afafaf",
              "trackMargin": {
                "top": 0,
                "bottom": 0,
                "left": 0,
                "right": 0
              }
            },
            "width": 1371,
            "height": 60,
            "header": "1\t2\t3\t4\t5\t6\t7\t8\t9\t10\t11\t12\t13\t14",
            "position": "top"
          },
          {
            "name": "hg38.gencode.v30.annotation.gtf.genePred.hgnc.longest.bed14.db",
            "created": "2019-04-11T15:12:04.391612Z",
            "project": "bLwQYp24jRG2YyAxGaGGwMg",
            "project_name": "",
            "description": "",
            "server": "",
            "tilesetUid": "",
            "uid": "5cb6b8a8-bb33-4935-856e-a62a582177a2",
            "type": "empty",
            "options": {
              "fontSize": 11,
              "labelColor": "black",
              "labelPosition": "hidden",
              "labelLeftMargin": 0,
              "labelRightMargin": 0,
              "labelTopMargin": 0,
              "labelBottomMargin": 0,
              "plusStrandColor": "black",
              "minusStrandColor": "black",
              "trackBorderWidth": 0,
              "trackBorderColor": "black",
              "showMousePosition": true,
              "mousePositionColor": "#999999",
              "geneAnnotationHeight": 10,
              "geneLabelPosition": "outside",
              "geneStrandSpacing": 4,
              "name": "hg38.gencode.v30.annotation.gtf.genePred.hgnc.longest.bed14.db",
              "backgroundColor": "white"
            },
            "width": 1371,
            "height": 20,
            "header": "1\t2\t3\t4\t5\t6\t7\t8\t9\t10\t11\t12\t13\t14",
            "position": "top"
          }
        ],
        "left": [],
        "center": [],
        "right": [],
        "bottom": [],
        "whole": [],
        "gallery": []
      },
      "initialXDomain": [
        1382518630,
        1382530873
      ],
      "initialYDomain": [
        1382518630,
        1382530873
      ],
      "layout": {
        "w": 12,
        "h": 12,
        "x": 0,
        "y": 0,
        "i": "CLH4ybW8ToynSKBby7aB4g",
        "moved": false,
        "static": false
      },
      "uid": "CLH4ybW8ToynSKBby7aB4g",
      "genomePositionSearchBoxVisible": true,
      "genomePositionSearchBox": {
        "autocompleteServer": "http://higlass.io/api/v1",
        "chromInfoServer": "http://higlass.io/api/v1",
        "visible": true,
        "chromInfoId": "hg38"
      }
    }
  ],
  "zoomLocks": {
    "locksByViewUid": {},
    "locksDict": {}
  },
  "locationLocks": {
    "locksByViewUid": {},
    "locksDict": {}
  },
  "valueScaleLocks": {
    "locksByViewUid": {},
    "locksDict": {}
  }
};

export const groupsForRecommenderV1OptionGroup = {
  'dhsIndex' : {
    'hg38' : {
      'all' : 'All_733_biosamples'
    }
  }
};

export const hideClipboardCopiedAlertTime = 750;

export const defaultApplicationSimSearchMode = "default";
export const defaultApplicationSimSearchPaddingAbsolute = 1000;
export const defaultApplicationSimSearchSetPaddingAbsolute = 10000;
export const defaultApplicationSimSearchPaddingFraction = 0.2;
export const defaultSimSearchTableDataLongestNameLength = 4;
export const defaultSimSearchTableDataLongestAllowedNameLength = 20;

export const defaultApplicationSsrIdx = -1; // simsearch

export const defaultViewerKeyEventChangeEventDebounceTimeout = 100; // 750;
export const defaultViewerHistoryChangeEventDebounceTimeout = 750;

export const applicationViewerHgViewPaddingTop = 20;
export const applicationViewerHgViewPaddingBottom = 20;

export const queryTargetViewerHitLabel = "Suggestion";
export const queryTargetViewerHitsHeaderLabel = "Suggestions";

export const appDataSourceURLPrefixes = {
  "AmazonCDN": "https://d1y3bo4esmnv83.cloudfront.net",
  "Altius":    "https://resources.altius.org/~areynolds/public/fiberview/052524",
};
export const appDefaultDataSourceURLPrefixKey = "AmazonCDN";
export const appAltiusDataSourceURLPrefixKey =  "Altius";

export const masterlistEncode2020DHSPrefix = "masterlist_DHSs_733samples_WM20180608_all_mean_signal_colorsMax.bed.unc.b12.lf.AR20210927.withBiosampleCounts";
export const masterlistEncode2024DHSPrefix = "encode2024.masterlist.only_autosomes.filtered.proc.042924";
export const masterlistEncode2024DHSBAMURL = `${appDataSourceURLPrefixes['AmazonCDN']}/${masterlistEncode2024DHSPrefix}.bam`;
export const masterlistEncode2024DHSBAIURL = `${masterlistEncode2024DHSBAMURL}.bai`;

export const appIndexDHSTypeMetadata = {
  "encode2020IndexDHS" : { 
    "prefix": masterlistEncode2020DHSPrefix,
    "label": "733-sample",
    "hgViewMetadata": {
      "group": "Meuleman 2020",
      "set": "",
      "backgroundColor": "#ffffff",
      "biosampleCount": 733,
      "itemRGBMap": {
        "255,229,0": "Placental / trophoblast",
        "254,129,2": "Lymphoid",
        "255,0,0": "Myeloid / erythroid",
        "7,175,0": "Cardiac",
        "76,125,20": "Musculoskeletal",
        "65,70,19": "Vascular / endothelial",
        "5,193,217": "Primitive / embryonic",
        "4,103,253": "Neural",
        "0,149,136": "Digestive",
        "187,45,212": "Stromal A",
        "122,0,255": "Stromal B",
        "74,104,118": "Renal / cancer",
        "8,36,91": "Cancer / epithelial",
        "185,70,29": "Pulmonary development",
        "105,33,8": "Organ development / renal",
        "195,195,195": "Tissue invariant"
      },
    },
  },
  "encode2024IndexDHSOriginal" : { 
    "prefix": masterlistEncode2024DHSPrefix,
    "label": "3157-sample",
    "hgViewMetadata": {
      "group": "Encode 2024",
      "set": "",
      "backgroundColor": "#ffffff",
      "biosampleCount": 3517,
      "itemRGBMap": {
        "240,248,255": "Lung cancer cell lines",
        "211,211,211": "Natural killer cells",
        "255,235,205": "Respiratory / muscular",
        "139,69,19": "Cerebellar hemisphere",
        "255,218,185": "B-cells (A)",
        "255,240,245": "Brain",
        "210,105,30": "K562",
        "244,164,96": "CD4/3 (A)",
        "8,36,91": "T-cells (A)",
        "255,0,0": "Gastro-endocrine system",
        "65,70,19": "Pluripotent cells",
        "0,149,136": "Epithelial",
        "76,125,20": "Stromal cells",
        "185,70,29": "CD4/3 (B)",
        "105,33,8": "Renal",
        "7,175,0": "Myeloid",
        "4,103,253": "Mixed",
        "255,229,0": "Brain",
        "74,104,118": "T-cells (B)",
        "254,129,2": "CD4/3 (C)",
        "122,0,255": "MCF-7",
        "5,193,217": "Cerebral cortex",
        "187,45,212": "T-47D",
        "195,195,195": "CD34+ progenitor",
      },
    },
  },
  "encode2024IndexDHS011924" : { 
    "prefix": masterlistEncode2024DHSPrefix,
    "label": "3157-sample",
    "hgViewMetadata": {
      "group": "Encode 2024",
      "set": "",
      "backgroundColor": "#ffffff",
      "biosampleCount": 3517,
      "itemRGBMap": {
        "140,198,63":    "Lung cancer cell lines",
        "187,45,212":    "Natural killer cells",
        "221,226,35":    "Respiratory / muscular",
        "46,151,188":    "Cerebellar hemisphere",
        "230,0,155":     "B-cells (A)",
        "32,117,147":    "Brain",
        "146,23,26":     "K562",
        "184,70,27":     "CD4/3 (A)",
        "251,181,113":   "T-cells (A)",
        "0,173,149":     "Gastro-endocrine system",
        "255,229,35":    "Pluripotent cells",
        "255,218,185":   "Epithelial",
        "107,84,163":    "Stromal cells",
        "230,85,13":     "CD4/3 (B)",
        "82,110,125":    "Renal",
        "174,22,24":     "Myeloid",
        "194,194,194":   "Mixed",
        "16,89,134":     "Brain",
        "254,212,222":   "T-cells (B)",
        "253,141,60":    "CD4/3 (C)",
        "44,146,74":     "MCF-7",
        "55,193,241":    "Cerebral cortex",
        "44,103,74":     "T-47D",
        "237,32,36":     "CD34+ progenitor",
      },
    },
  },
  "encode2024IndexDHS042924" : { 
    "prefix": masterlistEncode2024DHSPrefix,
    "label": "4078-sample",
    "hgViewMetadata": {
      "group": "Encode 2024",
      "set": "",
      "backgroundColor": "#ffffff",
      "biosampleCount": 4078,
      "itemRGBMap": {
        "231,233,233": "Tissue invariant",
        "69,49,107": "Stromal A",
        "255,222,0": "Myeloid (Monocyte)",
        "8,36,91": "Adult tissues / Muscle",
        "254,243,187": "Epithelial A",
        "255,118,0": "Myeloid (Macrophage)",
        "4,121,253": "Neural (Basal ganglia)",
        "117,156,213": "Endothelial",
        "212,142,184": "Placental A",
        "65,70,19": "Adult tissues / Cardiac",
        "74,104,118": "Digestive",
        "237,32,36": "Erythroid",
        "255,194,106": "Renal (Epithelial)",
        "194,255,237": "Respiratory (Fetal)",
        "161,239,255": "Neural (Fetal)",
        "50,166,58": "Adult tissues / Endocrine",
        "140,198,63": "Cardiac (Fetal)",
        "174,22,24": "Myeloid progenitor",
        "194,255,153": "Musculoskeletal (Fetal)",
        "255,218,185": "Epithelial B",
        "107,84,163": "Stromal B",
        "255,171,241": "Embryonic",
        "0,173,149": "Adrenal",
        "208,210,248": "Renal (Fetal)",
        "255,155,199": "Placental B",
        "55,193,241": "Neural (Cereballar)",
        "187,45,212": "Lymphoid (B-cell)",
        "59,231,150": "Thyroid",
        "230,0,155": "Lymphoid (T-cell/NK-cell)",
      },
    },
  },
};